import React, { useState, useEffect, useRef, act } from 'react';
import { Tooltip } from 'primereact/tooltip';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import _ from 'lodash';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { downloadDocs, generateWPlan, updateNewWinplan, wplanActionComplete } from '../../../../Services/opportunityService';
import { MultiSelect } from 'primereact/multiselect';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import { InputIcon } from 'primereact/inputicon';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import { Dialog } from 'primereact/dialog';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import { getBranchUser } from '../../../../Services/userService';
import Moment from "moment";
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import socket from '../../../../socket';
import { clearCompletedNotification } from '../../../../Services/notificationService';
import { useNavigate } from 'react-router-dom';

const ActivityPlannar = (props) => {
	const [loading, setLoading] = useState(false);
	const [newModule, setNewModule] = useState({});
	const [opportunityData, setOpportunityData] = useState({});
	const [selectedOptionCase, setSelectedOptionCase] = useState([]);
	const [selectedOption, setSelectedOption] = useState([]);
	const [showDropdown, setShowDropdown] = useState(false);
	const [groupData, setGroupData] = useState([]);
	const [selectedModel, setSelectedModel] = useState(props.planData);
	const [selectedOwner, setSelectedOwner] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState([]);
	const [winPlan, setWinPlan] = useState([]);
	const [winPlanData, setWinPlanData] = useState({});
	const [winPlanCategoryModal, setWinPlanCategoryModal] = useState(false);
	const [editWinPlan, setEditWinPlan] = useState(false);
	const [editWinPlanMgmt, setEditWinPlanMgmt] = useState(false);
	const [winPlanMgmtCategoryModal, setWinPlanMgmtCategoryModal] = useState(false);
	const [winPlanMgmtData, setWinPlanMgmtData] = useState({});
	const [name, setName] = useState([]);
	const [showWinPlanHeader, setShowWinPlanHeader] = useState(false);
	const [planIdentification, setPlanIdentification] = useState([]);
	const [planSections, setPlanSections] = useState([]);
	const [selectedIndex, setSelectedIndex] = useState([]);
	const [noAddition, setNoAddition] = useState(true);
	const [winPlanManagementCompletedModal, setWinPlanManagementCompletedModal] = useState(false);
	const [isWinPlanActionOwnerSame, setIsWinPlanActionOwnerSame] = useState(false);
	const [completePercentage, setCompletePercentage] = useState('');
	const [completeCount, setCompleteCount] = useState('');
	const [totalCount, setTotalCount] = useState('');
	const [modalNew, setModalNew] = useState(props.modelNew);
	const [isCompletedState, setIsCompletedState] = useState(false);
	const [parentIndex, setParentIndex] = useState(0);
	const [subIndex, setSubIndex] = useState(0);
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const [errors, setErrors] = useState(false);
	const navigate = useNavigate()
	const statusFilter = [
		{ _id: 1, label: "Completed", value: true },
		{ _id: 2, label: "Incomplete", value: false },
	];

	var enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}

	const toastRef = useRef();

	useEffect(() => {
		if (props.fieldData.pipelineWinplanSections) {
			let obj1 = _.find(props?.fieldData?.pipelineWinplanSections, { section_name: "winPlan Identification" })?.display_name;
			let obj2 = _.find(props?.fieldData?.pipelineWinplanSections, { section_name: "winPlan Management" })?.display_name;
			let obj3 = _.find(props?.fieldData?.pipelineWinplanSections, { section_name: "Testimonials & Case Studies" })?.display_name;
			let combined = { obj1, obj2, obj3 };
			setNewModule(combined)
		}
	}, [props.fieldData.pipelineWinplanSections])

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props?.opportunityData)
			winplan_newSection(props?.opportunityData)
		}
		loadWinPlan()
	}, [props.opportunityData, props.relationshipOwner])

	useEffect(() => {
		if (props.testSections.length > 0) {
			for (var i = 0; i < props.testSections.length; i++) {
				if (props.testSections[i]?.theme.length > 0) {
					for (var j = 0; j < props.testSections[i].theme.length; j++) {
						props.testSections[i].theme[j].category = props.testSections[i].theme[j].theme_description;
						props.testSections[i].theme[j].action = props.testSections[i].theme[j].planned_action;
						props.testSections[i].theme[j].action_bydate = props.testSections[i].theme[j].win_plan_target_date;
						var new_action_owner = []
						for (let owner of props.relationshipOwner) {
							for (let action of props.testSections[i].theme[j].win_plan_user) {
								if (owner._id == action._id) {
									new_action_owner.push(owner)
								}
							}
						}
						props.testSections[i].theme[j].action_owner = new_action_owner;
					}
				}
			}
			setPlanSections(props.testSections)
		}
	}, [props.testSections])

	useEffect(() => {
		if (isCompletedState) {
			setPlanSections((prevState) => {
				const updatedPlanSections = [...prevState];

				updatedPlanSections[parentIndex] = {
					...updatedPlanSections[parentIndex],
					theme: updatedPlanSections[parentIndex]?.theme.map((item, i) =>
						i === subIndex ? { ...item, isCompleted: false } : item
					)
				};

				return updatedPlanSections;
			});
			setIsCompletedState(false)
		}
	}, [isCompletedState])

	useEffect(() => {
		if (groupData.length > 0 && props.planData) {
			const matchedSelectedModel = matchSelectedModelWithGroupData(props.planData, groupData);
			setSelectedModel(matchedSelectedModel);
		}
	}, [props.planData, groupData])

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			win_plan_section_new: planSections,
		}));
	}, [planSections]);

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			win_plan: {
				...prevData.win_plan,
				testimonial_required: opportunityData.win_plan?.testimonial_required,
				case_studies_required: opportunityData.win_plan?.case_studies_required
			},
		}));
	}, [opportunityData.win_plan]);

	const matchSelectedModelWithGroupData = (selectedModel, groupData) => {
		const matchedModel = selectedModel.map(selectedItem => {
			for (let group of groupData) {
				const foundItem = group.items.find(item => item.id === selectedItem.id);
				if (foundItem) {
					return foundItem;
				}
			}
			return null;
		}).filter(item => item !== null);

		return matchedModel;
	};

	const filterRecords = (records, filter1, filter2, value, statusValue) => {
		var showSec = false;
		for (var rec = 0; rec < records.length; rec++) {
			var showRec = false;
			var isWinAOMatching = false,
				isWinStatMatching = false;
			for (var ao = 0; ao < value.length; ao++) {
				for (var aoId = 0; aoId < records[rec][filter1].length; aoId++) {
					if (records[rec][filter1][aoId]._id == value[ao]._id) {
						isWinAOMatching = true;
						break;
					}
				}
			}
			for (var stat = 0; stat < statusValue.length; stat++) {
				if (records[rec][filter2] == statusValue[stat]) {
					isWinStatMatching = true;
					break;
				}
			}
			if (value.length == 0 && statusValue.length == 0) {
				records[rec].showRec = true;
			} else if (value.length > 0 && statusValue.length > 0) {
				records[rec].showRec = isWinAOMatching && isWinStatMatching;
			} else if (value.length > 0 || statusValue.length > 0) {
				records[rec].showRec = isWinAOMatching || isWinStatMatching;
			}
		}
		if (value.length == 0 && statusValue.length == 0) {
			records.showSec = true;
		} else {
			var result = _.find(records, { showRec: true });
			if (!_.isEmpty(result)) {
				records.showSec = true;
			} else {
				records.showSec = false;
			}
		}
		return records;
	}

	const winplan_newSection = (opportunityDetails) => {
		var winplan = {
			opportunity_needs: [],
			opportunity_objectives: [],
			opportunity_values: [],
			stakeholder_needs: [],
			stakeholder_objectives: [],
			project_needs: [],
			project_objectives: [],
			project_values: [],
			other_sections: [],
		};
		var complicatpercentage = 0;
		var completedCount = 0;
		var totalCount = 0;
		if (opportunityDetails.client?.opportunity_needs.length) {
			var needsArray = []
			opportunityDetails?.client?.opportunity_needs?.forEach((need) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of need.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				const oppNeeds = {
					_id: need._id,
					needs: need.needs,
					category: need.category,
					planned_action: need.planned_action,
					action_taken: need.action_taken,
					action_owner: new_action_owner,
					action_bydate: need.action_bydate,
					programme_impact: need.programme_impact,
					potential_saving: need.potential_saving,
					actual_saving: need.actual_saving,
					comments: need.comments,
					location_ref: need.location_ref,
					isCompleted: need.isCompleted,
				};

				totalCount += 1;
				if (need.isCompleted === true) {
					completedCount += 1;
				}

				needsArray.push(oppNeeds);
			});

			var result = filterRecords(needsArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				opportunity_needs: needsArray,
			}));
		}
		if (opportunityDetails?.client?.opportunity_objectives?.length) {
			var objectivesArray = []
			opportunityDetails?.client?.opportunity_objectives?.forEach((obj) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of obj.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				const oppNeeds = {
					_id: obj._id,
					objectives: obj.objectives,
					category: obj.category,
					planned_action: obj.planned_action,
					action_taken: obj.action_taken,
					action_owner: new_action_owner,
					action_bydate: obj.action_bydate,
					programme_impact: obj.programme_impact,
					potential_saving: obj.potential_saving,
					actual_saving: obj.actual_saving,
					comments: obj.comments,
					location_ref: obj.location_ref,
					isCompleted: obj.isCompleted,
				};

				totalCount += 1;
				if (obj.isCompleted === true) {
					completedCount += 1;
				}

				objectivesArray.push(oppNeeds);
			});

			var result = filterRecords(objectivesArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				opportunity_objectives: objectivesArray,
			}));
		}

		if (opportunityDetails?.client?.opportunity_values?.length) {
			var valuesArray = []
			opportunityDetails?.client?.opportunity_values?.forEach((val) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of val.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				const oppNeeds = {
					_id: val._id,
					values: val.values,
					category: val.category,
					planned_action: val.planned_action,
					action_taken: val.action_taken,
					action_owner: new_action_owner,
					action_bydate: val.action_bydate,
					programme_impact: val.programme_impact,
					potential_saving: val.potential_saving,
					actual_saving: val.actual_saving,
					comments: val.comments,
					location_ref: val.location_ref,
					isCompleted: val.isCompleted,
				};

				totalCount += 1;
				if (val.isCompleted === true) {
					completedCount += 1;
				}

				valuesArray.push(oppNeeds);
			});

			var result = filterRecords(valuesArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				opportunity_values: valuesArray,
			}));
		}
		if (opportunityDetails?.win_plan?.project_needs.length) {
			var projectNeedsArray = []
			opportunityDetails?.win_plan?.project_needs?.forEach((proj) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of proj.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				var projNeeds = {
					_id: proj._id,
					needs: proj.needs,
					category: proj.category,
					planned_action: proj.planned_action,
					action_taken: proj.action_taken,
					action_owner: new_action_owner,
					action_bydate: proj.action_bydate,
					programme_impact: proj.programme_impact,
					potential_saving: proj.potential_saving,
					actual_saving: proj.actual_saving,
					comments: proj.comments,
					location_ref: proj.location_ref,
					isCompleted: proj.isCompleted,
				};

				totalCount += 1;
				if (proj.isCompleted === true) {
					completedCount += 1;
				}

				projectNeedsArray.push(projNeeds);
			});

			var result = filterRecords(projectNeedsArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				project_needs: projectNeedsArray,
			}));
		}

		if (opportunityDetails?.win_plan?.project_objectives.length) {
			var projectObjArray = []
			opportunityDetails?.win_plan?.project_objectives?.forEach((proj) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of proj.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				var projNeeds = {
					_id: proj._id,
					objectives: proj.objectives,
					category: proj.category,
					planned_action: proj.planned_action,
					action_taken: proj.action_taken,
					action_owner: new_action_owner,
					action_bydate: proj.action_bydate,
					programme_impact: proj.programme_impact,
					potential_saving: proj.potential_saving,
					actual_saving: proj.actual_saving,
					comments: proj.comments,
					location_ref: proj.location_ref,
					isCompleted: proj.isCompleted,
				};

				totalCount += 1;
				if (proj.isCompleted === true) {
					completedCount += 1;
				}

				projectObjArray.push(projNeeds);
			});

			var result = filterRecords(projectObjArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				project_objectives: projectObjArray,
			}));
		}
		if (opportunityDetails?.win_plan?.project_values.length) {
			var projectValuesArray = []
			opportunityDetails?.win_plan?.project_values?.forEach((proj) => {
				var new_action_owner = []
				for (let owner of props.relationshipOwner) {
					for (let action of proj.action_owner) {
						if (action.id != undefined) {
							if (owner._id == action.id) {
								new_action_owner.push(owner)
							}
						} else {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
				}
				var projNeeds = {
					_id: proj._id,
					values: proj.values,
					category: proj.category,
					planned_action: proj.planned_action,
					action_taken: proj.action_taken,
					action_owner: new_action_owner,
					action_bydate: proj.action_bydate,
					programme_impact: proj.programme_impact,
					potential_saving: proj.potential_saving,
					actual_saving: proj.actual_saving,
					comments: proj.comments,
					location_ref: proj.location_ref,
					isCompleted: proj.isCompleted,
				};

				totalCount += 1;
				if (proj.isCompleted === true) {
					completedCount += 1;
				}

				projectValuesArray.push(projNeeds);
			});

			var result = filterRecords(projectValuesArray, "action_owner", "isCompleted", [], []);

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				project_values: projectValuesArray,
			}));
		}
		if (opportunityDetails?.advisor?.length > 0) {
			var stakeholderNeeds = [];
			var stakeholderObjectives = [];
			opportunityDetails.advisor.forEach((adv) => {
				var stackNeeds = { advisor: adv.advisor_name };
				var stackObjs = { advisor: adv.advisor_name };
				stackNeeds.objects = [];
				stackObjs.objects = [];
				adv.advisor_needs.forEach((adv1) => {
					var new_action_owner = []
					for (let owner of props.relationshipOwner) {
						for (let action of adv1.action_owner) {
							if (action.id != undefined) {
								if (owner._id == action.id) {
									new_action_owner.push(owner)
								}
							} else {
								if (owner._id == action._id) {
									new_action_owner.push(owner)
								}
							}
						}
					}
					stackNeeds.objects.push({
						needs: adv1.needs,
						category: adv1.category,
						planned_action: adv1.planned_action,
						action_taken: adv1.action_taken,
						action_owner: new_action_owner,
						action_bydate: adv1.action_bydate,
						programme_impact: adv1.programme_impact,
						potential_saving: adv1.potential_saving,
						actual_saving: adv1.actual_saving,
						comments: adv1.comments,
						location_ref: adv1.location_ref,
						isCompleted: adv1.isCompleted,
						_id: adv1._id,
					});
				});
				adv.advisor_objectives.forEach((adv2) => {
					var new_action_owner = []
					for (let owner of props.relationshipOwner) {
						for (let action of adv2.action_owner) {
							if (owner._id == action._id) {
								new_action_owner.push(owner)
							}
						}
					}
					stackObjs.objects.push({
						objectives: adv2.objectives,
						category: adv2.category,
						planned_action: adv2.planned_action,
						action_taken: adv2.action_taken,
						action_owner: new_action_owner,
						action_bydate: adv2.action_bydate,
						programme_impact: adv2.programme_impact,
						potential_saving: adv2.potential_saving,
						actual_saving: adv2.actual_saving,
						comments: adv2.comments,
						location_ref: adv2.location_ref,
						isCompleted: adv2.isCompleted,
						_id: adv2._id,
					});
				});

				stakeholderNeeds.push(stackNeeds);
				stakeholderObjectives.push(stackObjs);
			});

			for (var stack_need = 0; stack_need < stakeholderNeeds.length; stack_need++) {
				var result = filterRecords(stakeholderNeeds[stack_need].objects, "action_owner", "isCompleted", [], []);
				if (stakeholderNeeds[stack_need].objects.length > 0) {
					stakeholderNeeds[stack_need].showSec = true;
					delete result.showSec;
					stakeholderNeeds[stack_need].objects = result;
				} else {
					stakeholderNeeds[stack_need].showSec = false;
					delete result.showSec;
					stakeholderNeeds[stack_need].objects = result;
				}
			}

			for (var stack_proj = 0; stack_proj < stakeholderObjectives.length; stack_proj++) {
				var result = filterRecords(stakeholderObjectives[stack_proj].objects, "action_owner", "isCompleted", [], []);
				if (stakeholderObjectives[stack_proj].objects.length > 0) {
					stakeholderObjectives[stack_proj].showSec = true;
					delete result.showSec;
					stakeholderObjectives[stack_proj].objects = result;
				} else {
					stakeholderObjectives[stack_proj].showSec = false;
					delete result.showSec;
					stakeholderObjectives[stack_proj].objects = result;
				}
			}

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				stakeholder_needs: stakeholderNeeds,
				stakeholder_objectives: stakeholderObjectives
			}));
		}
		if (planSections.length != -1) {
			var otherSec = []
			planSections.forEach((section) => {
				var otherSections = {
					win_plan_section: section.win_plan_name,
					themes: [],
				};
				section.theme.forEach((s) => {
					var sect = {};
					sect.theme = s.win_plan_theme;
					sect.category = "";
					sect.planned_action = "";
					sect.location_ref = s.location_ref;
					sect.isCompleted = s.isCompleted;
					if (sect.action_owner = s.win_plan_user)
						otherSections.themes.push(sect);
				});

				otherSections.themes.forEach((themes) => {
					totalCount += 1;
					if (themes.isCompleted == true) {
						completedCount += 1;
					}
					complicatpercentage = ((completedCount / totalCount) * 100).toFixed(2);
				});

				otherSec.push(otherSections);
			});

			if (planSections.length > 0) {
				for (var win_plan = 0; win_plan < planSections.length; win_plan++) {
					var result = filterRecords(planSections[win_plan].theme, "win_plan_user", "isCompleted", [], []);
					if (planSections[win_plan].theme.length > 0) {
						planSections[win_plan].showSec = true;
						delete result.showSec;
						planSections[win_plan].theme = result;
					} else {
						planSections[win_plan].showSec = false;
						delete result.showSec;
						planSections[win_plan].theme = result;
					}
				}


				var reulst = _.find(planSections, { showSec: true });
				if (!_.isEmpty(reulst)) {
					setShowWinPlanHeader(true);
				} else {
					setShowWinPlanHeader(false);
				}
			}

			setWinPlan((prevWinPlan) => ({
				...prevWinPlan,
				other_sections: otherSec
			}));
		}
		setCompletePercentage(complicatpercentage)
		setTotalCount(totalCount)
		setCompleteCount(completedCount)
	}

	const loadWinPlan = () => {
		var planIdentificationData = [];
		var planLength = props.winPlanSection.length;
		for (var l = 0; l < planLength; l++) {
			var winThemes = props.reference_data.filter(
				(item) => item.display_name === props.winPlanSection[l].label
			);

			if (winThemes.length > 0) {
				var resLength = winThemes[0].option_choice.length;
				if (resLength > 0) {
					for (var i = 0; i < resLength; i++) {
						planIdentificationData.push({
							label: winThemes[0].option_choice[i].label,
							id: winThemes[0].option_choice[i]._id,
							winplan: winThemes[0].display_name,
						});
					}
				}
			}
		}
		setPlanIdentification(planIdentificationData)

		const groupedData = planIdentificationData.reduce((acc, item) => {
			const group = acc.find(g => g.label === item.winplan);
			if (group) {
				group.items.push({ label: item.label, id: item.id });
			} else {
				acc.push({
					label: item.winplan,
					items: [{ label: item.label, id: item.id }]
				});
			}
			return acc;
		}, []);
		setGroupData(groupedData)
	}

	const winPlanLoad = (e) => {
		setSelectedModel(e.value)
		var addedItem = [];
		var deletedItem = [];
		if (e.value.length > modalNew.length) {
			addedItem = _.difference(e.value, modalNew);
			var theme = [];
			theme.push({
				win_plan_theme: e.selectedOption.label,
				theme_description: "",
				win_plan_user: [],
				win_plan_target_date: "",
			});
			var groupName = ''
			for (let data of groupData) {
				for (let i of data.items) {
					if (i.id == e.selectedOption.id) {
						groupName = data.label
					}
				}
			}
			if (_.isEmpty(planSections)) {
				planSections.push({
					win_plan_name: groupName,
					theme: theme,
				});
				modalNew.push(addedItem[0]);
			} else {
				const foundStrategy = planSections.filter(
					(item) => item.win_plan_name === groupName
				)[0];

				if (foundStrategy) {
					var index = _.findIndex(planSections, { win_plan_name: groupName, });
					planSections[index].theme.push({
						win_plan_theme: e.selectedOption.label,
						theme_description: "",
						win_plan_user: [],
					});
					modalNew.push(e.selectedOption);
				} else {
					planSections.push({
						win_plan_name: groupName,
						theme: theme,
					});
					modalNew.push(e.selectedOption);
				}
			}
		} else if (e.value.length < modalNew.length) {
			deletedItem = _.difference(modalNew, e.value);
			var groupName = ''
			for (let data of groupData) {
				for (let i of data.items) {
					if (i.id == e.selectedOption.id) {
						groupName = data.label
					}
				}
			}
			var planIndex = _.findIndex(planSections, { win_plan_name: groupName, });
			var themeIndex = _.findIndex(planSections[planIndex]?.theme, { win_plan_theme: e.selectedOption.label, });

			planSections[planIndex]?.theme.splice(themeIndex, 1);
			if (_.isEmpty(planSections[planIndex]?.theme)) {
				planSections.splice(planIndex, 1);
			}
			var index = _.findIndex(modalNew, { label: e.selectedOption.label, });
			modalNew.splice(index, 1);
		}
		setModalNew(modalNew)
		winplan_newSection(opportunityData);
	};

	const groupedItemTemplate = (option) => {
		return (
			<div className="flex align-items-center">
				<div>{option.label}</div>
			</div>
		);
	};

	const generateRandomID = () => {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}

	const addCase = () => {
		const newRow = {
			_id: generateRandomID(),
			case_studies: ""
		};

		setOpportunityData((prevState) => ({
			...prevState,
			['win_plan']: {
				...prevState['win_plan'],
				['case_studies_required']: [
					...prevState['win_plan']['case_studies_required'],
					newRow
				],
			},
		}));
	};

	const deleteCase = () => {
		const updatedOptions = opportunityData.win_plan.case_studies_required.filter(
			(row) => !selectedOptionCase.includes(row)
		);
		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				case_studies_required: updatedOptions,
			},
		}));
		setSelectedOptionCase([]);
	};

	const handleCase = (index, field) => (e) => {
		const newDocumentName = [...opportunityData?.win_plan.case_studies_required];
		newDocumentName[index][field] = e.target.value;

		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				case_studies_required: newDocumentName, // Directly set the updated array here
			},
		}));
	};

	const caseTemplate = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className={(props.errors.includes('Case Studies Required') && row.case_studies == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
					value={row.case_studies}
					placeholder="Description"
					onChange={handleCase(index?.rowIndex, "case_studies")}
				/>
			</div>
		);
	};

	const columns = [
		{ field: "case_studies", header: _.find(props.fieldData.oppWinPlanTable, { table_name: "Case Studies Required" })?.display_name, body: caseTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const rowClickCase = async (data) => {
		setSelectedOptionCase(data)
	};

	const reorderClickCase = (data) => {
		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				case_studies_required: data,
			},
		}));
	}

	const addTestimonial = () => {
		const newRow = {
			_id: generateRandomID(),
			testimonial: ""
		};
		setOpportunityData((prevState) => ({
			...prevState,
			['win_plan']: {
				...prevState['win_plan'],
				['testimonial_required']: [
					...prevState['win_plan']['testimonial_required'],
					newRow
				],
			},
		}));
	};

	const deleteTestimonial = () => {
		const updatedOptions = opportunityData.win_plan.testimonial_required.filter(
			(row) => !selectedOption.includes(row)
		);
		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				testimonial_required: updatedOptions, // Replace testimonial_required with updatedOptions
			},
		}));
		setSelectedOption([]);
	};

	const handleTestimonial = (index, field) => (e) => {
		const newDocumentName = [...opportunityData?.win_plan.testimonial_required];
		newDocumentName[index][field] = e.target.value;

		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				testimonial_required: newDocumentName, // Directly set the updated array here
			},
		}));
	};

	const testimonialTemplate = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className={(props.errors.includes('Testimonial Required') && row.testimonial == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
					value={row.testimonial}
					placeholder="Description"
					onChange={handleTestimonial(index?.rowIndex, "testimonial")}
				/>
			</div>
		);
	};

	const columns1 = [
		{ field: "testimonial", header: _.find(props.fieldData.oppWinPlanTable, { table_name: "Testimonial Required" })?.display_name, body: testimonialTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const rowClick = async (data) => {
		setSelectedOption(data)
	};

	const reorderClick = (data) => {
		setOpportunityData((prevState) => ({
			...prevState,
			win_plan: {
				...prevState.win_plan,
				testimonial_required: data,
			},
		}));
	}

	// const generateWPlanReports = async () => {
	// 	try {
	// 		var opportunity_needs = winPlan.opportunity_needs != undefined ? winPlan?.opportunity_needs : []
	// 		var opportunity_objectives = winPlan.opportunity_objectives != undefined ? winPlan?.opportunity_objectives : []
	// 		var opportunity_values = winPlan.opportunity_values != undefined ? winPlan?.opportunity_values : []
	// 		var project_needs = winPlan.project_needs != undefined ? winPlan?.project_needs : []
	// 		var project_objectives = winPlan.project_objectives != undefined ? winPlan?.project_objectives : []
	// 		var project_values = winPlan.project_values != undefined ? winPlan?.project_values : []
	// 		var stakeholder_needs = winPlan.stakeholder_needs != undefined ? winPlan?.stakeholder_needs : []
	// 		var stakeholder_objectives = winPlan.stakeholder_objectives != undefined ? winPlan?.stakeholder_objectives : []

	// 		const response = await generateWPlan(globalOpportunityData._id, props.customerId, opportunity_needs, opportunity_objectives, opportunity_values, project_needs, project_objectives, project_values, stakeholder_needs, stakeholder_objectives, planSections, props.rdsScore, props.riskScores);
	// 		if (response.data) {
	// 			downloadDocs(response.data.fileName, token);
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
	const generateWPlanReports = async () => {
		try {
			setLoading(true);

			// Use optional chaining and fallback to empty arrays if undefined
			const opportunity_needs = winPlan.opportunity_needs ?? [];
			const opportunity_objectives = winPlan.opportunity_objectives ?? [];
			const opportunity_values = winPlan.opportunity_values ?? [];
			const project_needs = winPlan.project_needs ?? [];
			const project_objectives = winPlan.project_objectives ?? [];
			const project_values = winPlan.project_values ?? [];
			const stakeholder_needs = winPlan.stakeholder_needs ?? [];
			const stakeholder_objectives = winPlan.stakeholder_objectives ?? [];

			// Make the API call to generate the WPlan report
			const response = await generateWPlan(
				globalOpportunityData._id,
				props.customerId,
				opportunity_needs,
				opportunity_objectives,
				opportunity_values,
				project_needs,
				project_objectives,
				project_values,
				stakeholder_needs,
				stakeholder_objectives,
				planSections,
				props.rdsScore,
				props.riskScores
			);

			// Check the response and download the document if available
			if (response.data) {
				downloadDocs(response.data.fileName);
			} else {
				toastRef.current.showToast({
					type: "warning",
					message: "No report generated. Please check the input data.",
				});
			}
		} catch (error) {
			// Handle any errors gracefully
			toastRef.current.showToast({
				type: "error",
				message: "Failed to generate the WPlan report. Please try again or contact support.",
			});
		} finally {
			setLoading(false);
		}
	};


	const handleSelection = (value, statusValue) => {
		value.length > 0 ? setSelectedOwner(value) : setSelectedOwner([])
		statusValue.length > 0 ? setSelectedStatus(statusValue) : setSelectedStatus([])

		const updatedData = { ...winPlan };
		const updatedDataPlan = [...planSections];

		updatedData.opportunity_needs = filterRecords(updatedData?.opportunity_needs != undefined ? updatedData?.opportunity_needs : [], "action_owner", "isCompleted", value, statusValue);
		updatedData.opportunity_objectives = filterRecords(updatedData.opportunity_objectives != undefined ? updatedData.opportunity_objectives : [], "action_owner", "isCompleted", value, statusValue);
		updatedData.opportunity_values = filterRecords(updatedData.opportunity_values != undefined ? updatedData.opportunity_values : [], "action_owner", "isCompleted", value, statusValue);
		updatedData.project_needs = filterRecords(updatedData.project_needs != undefined ? updatedData.project_needs : [], "action_owner", "isCompleted", value, statusValue);
		updatedData.project_objectives = filterRecords(updatedData.project_objectives != undefined ? updatedData.project_objectives : [], "action_owner", "isCompleted", value, statusValue);
		updatedData.project_values = filterRecords(updatedData.project_values != undefined ? updatedData.project_values : [], "action_owner", "isCompleted", value, statusValue);
		if (Array.isArray(updatedData.stakeholder_needs)) {
			updatedData.stakeholder_needs.forEach((need) => {
				if (need.objects) {
					const result = filterRecords(need.objects, "action_owner", "isCompleted", value, statusValue);
					need.showSec = result.showSec;
					delete result.showSec;
					need.objects = result;
				}
			});
		}

		if (Array.isArray(updatedData.stakeholder_objectives)) {
			updatedData.stakeholder_objectives.forEach((objective) => {
				if (objective.objects) {
					const result = filterRecords(objective.objects, "action_owner", "isCompleted", value, statusValue);
					objective.showSec = result.showSec;
					delete result.showSec;
					objective.objects = result;
				}
			});
		}

		if (Array.isArray(updatedDataPlan)) {
			updatedDataPlan.forEach((plan) => {
				if (plan.theme) {
					const result = filterRecords(plan.theme, "win_plan_user", "isCompleted", value, statusValue);
					plan.showSec = result.showSec;
					delete result.showSec;
					plan.theme = result;
				}
			});
		}

		setWinPlan(updatedData)
		setPlanSections(updatedDataPlan)

		if (value.length == 0 && statusValue.length == 0)
			setShowWinPlanHeader(true);
		else {
			var reulst = _.find(planSections, { showSec: true });
			if (!_.isEmpty(reulst)) {
				setShowWinPlanHeader(true);
			} else {
				setShowWinPlanHeader(false);
			}
		}
	}

	const resetButton = () => {
		var owner = []
		var status = []
		setSelectedOwner(owner)
		setSelectedStatus(status)
		setShowDropdown(false)
		handleSelection(owner, status)
	}

	const toggleDropdown = () => {
		setShowDropdown(!showDropdown)
	}

	const addNewPlan = (value) => {
		if (value) {
			var selectedIndexes = selectedIndex.length > 0 ? selectedIndex : []

			if (!planSections) {
				var tmpSection = [];
				var tmpPlan = [];
				var testSections = []
				tmpSection.push({
					win_plan_theme: "New Theme",
					theme_description: "",
					planned_action: "",
					action_taken: "",
					win_plan_user: [],
				});
				tmpPlan.push({
					win_plan_name: "New Section",
					theme: tmpSection,
				});
				testSections.push(tmpPlan[0]);
				setPlanSections((prevState) => [
					...prevState,
					tmpPlan[0]
				]);
			} else if (selectedIndexes.length == 0) {
				var tmpSection = [];
				var tmpPlan = [];
				var testSections = []
				var newSectionName = "New Section";
				var alreadyHavNewWinSec = planSections.filter(
					(item) => item.win_plan_name === "New Section"
				);

				if (alreadyHavNewWinSec) {
					var i = 1;
					var j = 1;
					while (true) {
						var tmp = "New Section " + j;
						if (!testSections.filter((item) => item.win_plan_name === tmp)[0]) {
							newSectionName = "New Section " + j;
							break;
						}
						j++;
					}
				}
				tmpSection.push({
					win_plan_theme: "New Theme",
					theme_description: "",
					planned_action: "",
					action_taken: "",
					win_plan_user: [],
				});
				tmpPlan.push({
					win_plan_name: newSectionName,
					theme: tmpSection,
				});
				testSections.push(tmpPlan[0]);
				setPlanSections((prevState) => [
					...prevState,
					tmpPlan[0]
				]);
			}

			selectedIndexes.forEach(function (value, index) {
				if (planSections.indexOf(value) !== -1) {
					var tmpSection = [];
					var newSectionName = "New Theme";
					const foundItem = planSections.filter(
						(item) => item.win_plan_name === value.win_plan_name
					)[0];

					var index = planSections.indexOf(selectedIndexes[0]);
					const alreadyHavNewWinTheme = selectedIndexes[0].theme.filter(
						(item) => item.win_plan_theme === "New Theme"
					)[0];

					if (alreadyHavNewWinTheme) {
						var j = 1;
						while (true) {
							var tmp = "New Theme " + j;
							if (!selectedIndexes[0].theme.filter((item) => item.win_plan_theme === tmp)[0]) {
								newSectionName = "New Theme " + j;
								break;
							}

							j++;
						}
					}
					tmpSection.push({
						win_plan_theme: newSectionName,
						theme_description: "",
						planned_action: "",
						action_taken: "",
						win_plan_user: [],
					});
					setPlanSections((prevState) => {
						const updatedSections = [...prevState];

						updatedSections[index] = {
							...updatedSections[index],
							theme: [...updatedSections[index].theme, tmpSection[0]],
							checked: false
						};

						return updatedSections;
					});
				}
			});
		}
		setSelectedIndex([])
	}

	const removePlan = () => {
		// Define a new array to hold the updated planSections
		let updatedPlanSections = [...planSections];
		let updatedPlanData = [...props.planData];
		let updatedModelNew = [...modalNew];
		let updateSelectedModel = [...selectedModel]

		selectedIndex.forEach((item) => {
			if (item.action === 'deleteTheme') {
				updatedPlanSections.forEach((section, sectionIndex) => {
					const themeIndex = section.theme.findIndex(theme =>
						item.theme.some(itemTheme => itemTheme.win_plan_theme === theme.win_plan_theme && theme.checked == true)
					);
					if (themeIndex !== -1) {
						const themeToRemove = section.theme[themeIndex];
						const foundSecIndex = updatedPlanData.findIndex(data => data.label === themeToRemove.win_plan_theme);
						const foundModalIndex = updatedModelNew.findIndex(data => data.label === themeToRemove.win_plan_theme);
						const findSelectModel = updateSelectedModel.findIndex(data => data.label === themeToRemove.win_plan_theme);

						if (foundSecIndex !== -1) {
							updatedPlanData.splice(foundSecIndex, 1);
						}
						if (foundModalIndex !== -1) {
							updatedModelNew.splice(foundModalIndex, 1);
						}

						if (findSelectModel !== -1) {
							updateSelectedModel.splice(findSelectModel, 1);
						}

						// Remove the theme from the theme array
						section.theme.splice(themeIndex, 1);
						// If no themes are left in the section, remove the section
						if (section.theme.length === 0) {
							updatedPlanSections.splice(sectionIndex, 1);
						}
					}
				});
			} else if (item.action === 'deleteSection') {
				const sectionIndex = updatedPlanSections.findIndex(section =>
					section.win_plan_name === item.win_plan_name && section.checked == true
				);

				updatedPlanSections[sectionIndex].theme.forEach(theme => {
					const findSelectedModel = updateSelectedModel.findIndex(data => data.label === theme.win_plan_theme);
					const foundModalIndex = updatedModelNew.findIndex(data => data.label === theme.win_plan_theme);

					if (foundModalIndex !== -1) {
						updatedModelNew.splice(foundModalIndex, 1);
					}
					if (findSelectedModel !== -1) {
						updateSelectedModel.splice(findSelectedModel, 1);
					}
				})

				if (sectionIndex !== -1) {
					// Remove the entire section
					updatedPlanSections.splice(sectionIndex, 1);
				}
			}
		});
		// Update the state with the modified planSections
		setPlanSections(updatedPlanSections);
		setSelectedIndex([]);
		setModalNew(updatedModelNew)
		setSelectedModel(updateSelectedModel)
	}

	const openWinPlan = (edit, section, data, sectionName, headerName, index) => {
		var winPlanData = {};
		if (edit) {
			setEditWinPlan(true);
		} else {
			setEditWinPlan(false);
		}

		var status = ''
		if (data.isCompleted) {
			status = "Completed";
		} else {
			status = "Not Completed";
		}

		setWinPlanCategoryModal(true)
		var new_action_owner = []
		if (data.action_owner) {
			for (let owner of props.relationshipOwner) {
				for (let action of data.action_owner) {
					if (owner._id == action._id) {
						new_action_owner.push(owner)
					}
				}
			}
		}
		if (data.needs) {
			winPlanData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.needs,
				category: data.category,
				action: data.planned_action,
				action_bydate: data.action_bydate,
				status: status,
				index: index,
			};
			winPlanData.winPlanActionOwner = new_action_owner;
			setWinPlanData(winPlanData);
		} else if (data.objectives) {
			winPlanData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.objectives,
				category: data.category,
				action: data.planned_action,
				action_bydate: data.action_bydate,
				status: status,
				index: index,
			};
			winPlanData.winPlanActionOwner = new_action_owner;
			setWinPlanData(winPlanData);
		} else if (data.values) {
			winPlanData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.values,
				category: data.category,
				action: data.planned_action,
				action_bydate: data.action_bydate,
				status: status,
				index: index,
			};
			winPlanData.winPlanActionOwner = new_action_owner;
			setWinPlanData(winPlanData);
		} else if (data.theme) {
			winPlanData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.theme,
				category: data.category,
				action: data.planned_action,
				status: status,
				index: index,
			};
			winPlanData.winPlanActionOwner = new_action_owner;
			setWinPlanData(winPlanData);
		} else if (data.win_plan_theme) {
			var multiUsers = [];
			winPlanData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.win_plan_theme,
				category: data.theme_description,
				action: data.planned_action,
				action_bydate: data.action_bydate,
				status: status,
				index: index,
			};
			winPlanData.winPlanActionOwner = data.win_plan_user;
			setWinPlanData(winPlanData);
		}
	}

	// const user = async (winPlanMgmtData) => {
	// 	var name = [];
	// 	var data = await getBranchUser(props.customerId, tmpData.branch.branch_id)

	// 	if (data.data) {
	// 		for (var i = 0; i < winPlanMgmtData.action_owner.length; i++) {
	// 			for (var j = 0; j < data.length; j++) {
	// 				if (winPlanMgmtData.action_owner[i].id == data[j]._id) {
	// 					name.push(data[j].firstname + " " + data[j].surname);
	// 				}
	// 			}
	// 		}
	// 		name = name.toString();
	// 		setName(name)
	// 	}
	// 	name = [];
	// 	setName(name)
	// };

	const user = async (winPlanMgmtData) => {
		try {
			setLoading(true);
			var name = [];

			// Fetch branch users
			var data = await getBranchUser(props.customerId, tmpData.branch.branch_id);

			if (data && data.data) {
				// Loop through action owners and branch users to build names
				for (let i = 0; i < winPlanMgmtData.action_owner.length; i++) {
					for (let j = 0; j < data.data.length; j++) {
						if (winPlanMgmtData.action_owner[i].id === data.data[j]._id) {
							name.push(`${data.data[j].firstname} ${data.data[j].surname}`);
						}
					}
				}

				// Update state with concatenated names
				setName(name.join(", "));
			} else {
				toastRef.current.showToast({
					type: "error",
					message: "No data found for the specified branch."
				});
			}
		} catch (error) {
			// Handle any errors during the API request
			toastRef.current.showToast({
				type: "error",
				message: "Failed to fetch branch users. Please try again or contact Admin."
			});
		} finally {
			setLoading(false);
			if (!data || !data.data) {
				setName([]);
			}
		}
	};


	const openWinPlanMgmt = function (edit, section, data, sectionName, headerName, index) {
		var winPlanMgmtData = {};
		if (edit) {
			setEditWinPlanMgmt(true)
		} else {
			setEditWinPlanMgmt(false)
		}

		var status = ''
		if (data.isCompleted) {
			status = "Completed";
		} else {
			status = "Not Completed";
		}
		var new_action_owner = []
		if (data.action_owner && data.action_owner?.length > 0) {
			for (let owner of props.relationshipOwner) {
				for (let action of data.action_owner) {
					if (owner._id == action._id) {
						new_action_owner.push(owner)
					}
				}
			}
		} else if (data.win_plan_user && data.win_plan_user?.length > 0) {
			for (let owner of props.relationshipOwner) {
				for (let action of data.win_plan_user) {
					if (owner._id == action._id) {
						new_action_owner.push(owner)
					}
				}
			}
		}
		setWinPlanMgmtCategoryModal(true)
		if (data.needs) {
			winPlanMgmtData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.needs,
				action_taken: data.action_taken,
				action_owner: new_action_owner,
				action_bydate: data.action_bydate,
				programme_impact: data.programme_impact,
				potential_saving: data.potential_saving,
				actual_saving: data.actual_saving,
				comments: data.comments,
				location_ref: data.location_ref,
				status: status,
				index: index,
			};
			setWinPlanMgmtData(winPlanMgmtData)
			user(winPlanMgmtData);
		} else if (data.objectives) {
			winPlanMgmtData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.objectives,
				action_taken: data.action_taken,
				action_owner: new_action_owner,
				action_bydate: data.action_bydate,
				programme_impact: data.programme_impact,
				potential_saving: data.potential_saving,
				actual_saving: data.actual_saving,
				comments: data.comments,
				location_ref: data.location_ref,
				status: status,
				index: index,
			};
			setWinPlanMgmtData(winPlanMgmtData)
			user(winPlanMgmtData);
		} else if (data.values) {
			winPlanMgmtData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.values,
				action_taken: data.action_taken,
				action_owner: new_action_owner,
				action_bydate: data.action_bydate,
				programme_impact: data.programme_impact,
				potential_saving: data.potential_saving,
				actual_saving: data.actual_saving,
				comments: data.comments,
				location_ref: data.location_ref,
				status: status,
				index: index,
			};
			setWinPlanMgmtData(winPlanMgmtData)
			user(winPlanMgmtData);
		} else if (data.theme) {
			winPlanMgmtData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.theme,
				action_taken: data.action_taken,
				action_owner: new_action_owner,
				action_bydate: data.action_bydate,
				programme_impact: data.programme_impact,
				potential_saving: data.potential_saving,
				actual_saving: data.actual_saving,
				comments: data.comments,
				location_ref: data.location_ref,
				status: status,
				index: index,
			};
			setWinPlanMgmtData(winPlanMgmtData)
			user(winPlanMgmtData);
		} else if (data.win_plan_theme) {
			winPlanMgmtData = {
				section: section,
				sectionName: sectionName,
				headerName: headerName,
				theme: data.win_plan_theme,
				action_taken: data.action_taken,
				action_owner: new_action_owner,
				action_bydate: data.action_bydate,
				programme_impact: data.programme_impact,
				potential_saving: data.potential_saving,
				actual_saving: data.actual_saving,
				comments: data.theme_description,
				location_ref: data.location_ref,
				status: status,
				index: index,
			};
			setWinPlanMgmtData(winPlanMgmtData)
			user(winPlanMgmtData);
		}
	};

	const closePopup = () => {
		setWinPlanCategoryModal(false)
	}

	const saveWinplan = async () => {
		try {
			if (winPlan && winPlanData) {
				var section_id = "";
				if (winPlanData.section === "Opportunity Needs") {
					for (var opp_need = 0; opp_need < winPlan?.opportunity_needs?.length; opp_need++) {
						if (winPlanData.theme === winPlan?.opportunity_needs[opp_need].needs) {
							winPlan.opportunity_needs[opp_need].category = winPlanData.category;
							winPlan.opportunity_needs[opp_need].planned_action = winPlanData.action;
							winPlan.opportunity_needs[opp_need].action_bydate = winPlanData.action_bydate;
							winPlan.opportunity_needs[opp_need].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.opportunity_needs[opp_need].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "opportunity_needs";
				} else if (winPlanData.section === "Opportunity Objectives") {
					for (var opp_obj = 0; opp_obj < winPlan.opportunity_objectives.length; opp_obj++) {
						if (winPlanData.theme === winPlan.opportunity_objectives[opp_obj].objectives) {
							winPlan.opportunity_objectives[opp_obj].category = winPlanData.category;
							winPlan.opportunity_objectives[opp_obj].planned_action = winPlanData.action;
							winPlan.opportunity_objectives[opp_obj].action_bydate = winPlanData.action_bydate;
							winPlan.opportunity_objectives[opp_obj].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.opportunity_objectives[opp_obj].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "opportunity_objectives";
				} else if (winPlanData.section === "Opportunity Values") {
					for (var opp_val = 0; opp_val < winPlan.opportunity_values.length; opp_val++) {
						if (winPlanData.theme === winPlan.opportunity_values[opp_val].values) {
							winPlan.opportunity_values[opp_val].category = winPlanData.category;
							winPlan.opportunity_values[opp_val].planned_action = winPlanData.action;
							winPlan.opportunity_values[opp_val].action_bydate = winPlanData.action_bydate;
							winPlan.opportunity_values[opp_val].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.opportunity_values[opp_val].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "opportunity_values";
				} else if (winPlanData.section === "Project Needs") {
					for (var proj_need = 0; proj_need < winPlan.project_needs.length; proj_need++) {
						if (winPlanData.theme === winPlan.project_needs[proj_need].needs) {
							winPlan.project_needs[proj_need].category = winPlanData.category;
							winPlan.project_needs[proj_need].planned_action = winPlanData.action;
							winPlan.project_needs[proj_need].action_bydate = winPlanData.action_bydate;
							winPlan.project_needs[proj_need].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.project_needs[proj_need].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "project_needs";
				} else if (winPlanData.section === "Project Objectives") {
					for (var proj_obj = 0; proj_obj < winPlan.project_objectives.length; proj_obj++) {
						if (winPlanData.theme === winPlan.project_objectives[proj_obj].objectives) {
							winPlan.project_objectives[proj_obj].category = winPlanData.category;
							winPlan.project_objectives[proj_obj].planned_action = winPlanData.action;
							winPlan.project_objectives[proj_obj].action_bydate = winPlanData.action_bydate;
							winPlan.project_objectives[proj_obj].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.project_objectives[proj_obj].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "project_objectives";
				} else if (winPlanData.section === "Project Values") {
					for (var proj_val = 0; proj_val < winPlan.project_values.length; proj_val++) {
						if (winPlanData.theme === winPlan.project_values[proj_val].values) {
							winPlan.project_values[proj_val].category = winPlanData.category;
							winPlan.project_values[proj_val].planned_action = winPlanData.action;
							winPlan.project_values[proj_val].action_bydate = winPlanData.action_bydate;
							winPlan.project_values[proj_val].win_plan_user = winPlanData.winPlanActionOwner;
							winPlan.project_values[proj_val].action_owner = winPlanData.winPlanActionOwner;
						}
					}
					section_id = "project_values";
				} else if (winPlanData.headerName === "Stakeholder Needs") {
					for (var stack_need = 0; stack_need < winPlan.stakeholder_needs.length; stack_need++) {
						if (winPlanData.sectionName === winPlan.stakeholder_needs[stack_need].advisor) {
							for (var need = 0; need < winPlan.stakeholder_needs[stack_need].objects.length; need++) {
								if (winPlanData.theme === winPlan.stakeholder_needs[stack_need].objects[need].needs) {
									winPlan.stakeholder_needs[stack_need].objects[need].category = winPlanData.category;
									winPlan.stakeholder_needs[stack_need].objects[need].planned_action = winPlanData.action;
									winPlan.stakeholder_needs[stack_need].objects[need].action_bydate = winPlanData.action_bydate;
									winPlan.stakeholder_needs[stack_need].objects[need].win_plan_user = winPlanData.winPlanActionOwner;
									winPlan.stakeholder_needs[stack_need].objects[need].action_owner = winPlanData.winPlanActionOwner;
								}
							}
						}
					}
					section_id = "stakeholder_needs";
				} else if (winPlanData.headerName === "Stakeholder Objectives") {
					for (var stack_obj = 0; stack_obj < winPlan.stakeholder_objectives.length; stack_obj++) {
						if (winPlanData.sectionName === winPlan.stakeholder_objectives[stack_obj].advisor) {
							for (var obj = 0; obj < winPlan.stakeholder_objectives[stack_obj].objects.length; obj++) {
								if (winPlanData.theme === winPlan.stakeholder_objectives[stack_obj].objects[obj].objectives) {
									winPlan.stakeholder_objectives[stack_obj].objects[obj].category = winPlanData.category;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].planned_action = winPlanData.action;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].action_bydate = winPlanData.action_bydate;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].win_plan_user = winPlanData.winPlanActionOwner;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].action_owner = winPlanData.winPlanActionOwner;
								}
							}
						}
					}
					section_id = "stakeholder_objectives";
				} else if (winPlanData.headerName === "Plan Themes") {
					for (var winPlanSec = 0; winPlanSec < planSections.length; winPlanSec++) {
						if (winPlanData.sectionName === planSections[winPlanSec].win_plan_name) {
							for (var winTheme = 0; winTheme < planSections[winPlanSec].theme.length; winTheme++) {
								if (winPlanData.theme === planSections[winPlanSec].theme[winTheme].win_plan_theme) {
									planSections[winPlanSec].theme[winTheme].theme_description = winPlanData.category;
									planSections[winPlanSec].theme[winTheme].planned_action = winPlanData.action;
									planSections[winPlanSec].theme[winTheme].win_plan_user = winPlanData.winPlanActionOwner;
									planSections[winPlanSec].theme[winTheme].win_plan_target_date = winPlanData.action_bydate;
								}
							}
						}
					}
					section_id = "Win Plan Themes";
				}
				if (winPlanData.headerName === "Stakeholder Objectives" || winPlanData.headerName === "Stakeholder Needs") {
					var stackWinPlan = _.find(winPlan[section_id], function (win) {
						return win.advisor === winPlanData.sectionName;
					});
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, stackWinPlan, winPlanData.sectionName)
					if (response.data.success) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + " Updated"
						});
						props.getData('success');
					}
				} else if (winPlanData.headerName === "Plan Themes") {
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, planSections, winPlanData.sectionName)
					if (response.data.success) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + " Updated"
						});
						props.getData('success');
					}
				} else {
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, winPlan[section_id], winPlanData.sectionName)
					if (response.data.success == true) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + " Updated"
						});
						props.getData('success');
					}
				};
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Reference Field is Invalid"
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to save. Please try again or contact Admin."
			});
		}
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						editWinPlan ?
							<>
								<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closePopup()} />
								<ButtonElement type="submit" label="Save" className="save-button" onClick={() => saveWinplan()} />
							</>
							:
							<ButtonElement type="submit" label="Cancel" className="cancel-new-button" onClick={() => closePopup()} />
					}
				</div>
			</div>
		);
	};

	const closePopupMgmt = () => {
		setWinPlanMgmtCategoryModal(false)
	}

	const saveWinplanMgmt = async () => {
		var reference_field = winPlanMgmtData.location_ref;
		if (winPlan && winPlanMgmtData) {
			if (isValidURL === false) {
				toastRef.current.showToast({
					type: 'error',
					message: "Enter valid reference Field"
				});
				setErrors(true)
			} else {
				var section_id = "";
				if (winPlanMgmtData.section === "Opportunity Needs") {
					for (var opp_need = 0; opp_need < winPlan?.opportunity_needs.length; opp_need++) {
						if (winPlanMgmtData.theme === winPlan?.opportunity_needs[opp_need].needs) {
							winPlan.opportunity_needs[opp_need].comments = winPlanMgmtData.comments;
							winPlan.opportunity_needs[opp_need].action_taken = winPlanMgmtData.action_taken;
							winPlan.opportunity_needs[opp_need].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.opportunity_needs[opp_need].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.opportunity_needs[opp_need].action_owner = winPlanMgmtData.action_owner;
							winPlan.opportunity_needs[opp_need].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "opportunity_needs";
				} else if (winPlanMgmtData.section === "Opportunity Objectives") {
					for (var opp_obj = 0; opp_obj < winPlan.opportunity_objectives.length; opp_obj++) {
						if (winPlanMgmtData.theme === winPlan.opportunity_objectives[opp_obj].objectives) {
							winPlan.opportunity_objectives[opp_obj].comments = winPlanMgmtData.comments;
							winPlan.opportunity_objectives[opp_obj].action_taken = winPlanMgmtData.action_taken;
							winPlan.opportunity_objectives[opp_obj].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.opportunity_objectives[opp_obj].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.opportunity_objectives[opp_obj].action_owner = winPlanMgmtData.action_owner;
							winPlan.opportunity_objectives[opp_obj].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "opportunity_objectives";
				} else if (winPlanMgmtData.section === "Opportunity Values") {
					for (var opp_val = 0; opp_val < winPlan.opportunity_values.length; opp_val++) {
						if (winPlanMgmtData.theme === winPlan.opportunity_values[opp_val].values) {
							winPlan.opportunity_values[opp_val].comments = winPlanMgmtData.comments;
							winPlan.opportunity_values[opp_val].action_taken = winPlanMgmtData.action_taken;
							winPlan.opportunity_values[opp_val].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.opportunity_values[opp_val].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.opportunity_values[opp_val].action_owner = winPlanMgmtData.action_owner;
							winPlan.opportunity_values[opp_val].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "opportunity_values";
				} else if (winPlanMgmtData.section === "Project Needs") {
					for (var proj_need = 0; proj_need < winPlan.project_needs.length; proj_need++) {
						if (winPlanMgmtData.theme === winPlan.project_needs[proj_need].needs) {
							winPlan.project_needs[proj_need].comments = winPlanMgmtData.comments;
							winPlan.project_needs[proj_need].action_taken = winPlanMgmtData.action_taken;
							winPlan.project_needs[proj_need].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.project_needs[proj_need].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.project_needs[proj_need].action_owner = winPlanMgmtData.action_owner;
							winPlan.project_needs[proj_need].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "project_needs";
				} else if (winPlanMgmtData.section === "Project Objectives") {
					for (var proj_obj = 0; proj_obj < winPlan.project_objectives.length; proj_obj++) {
						if (winPlanMgmtData.theme === winPlan.project_objectives[proj_obj].objectives) {
							winPlan.project_objectives[proj_obj].comments = winPlanMgmtData.comments;
							winPlan.project_objectives[proj_obj].action_taken = winPlanMgmtData.action_taken;
							winPlan.project_objectives[proj_obj].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.project_objectives[proj_obj].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.project_objectives[proj_obj].action_owner = winPlanMgmtData.action_owner;
							winPlan.project_objectives[proj_obj].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "project_objectives";
				} else if (winPlanMgmtData.section === "Project Values") {
					for (var proj_val = 0; proj_val < winPlan.project_values.length; proj_val++) {
						if (winPlanMgmtData.theme === winPlan.project_values[proj_val].values) {
							winPlan.project_values[proj_val].comments = winPlanMgmtData.comments;
							winPlan.project_values[proj_val].action_taken = winPlanMgmtData.action_taken;
							winPlan.project_values[proj_val].action_bydate = winPlanMgmtData.action_bydate;
							winPlan.project_values[proj_val].win_plan_user = winPlanMgmtData.winPlanActionOwner;
							winPlan.project_values[proj_val].action_owner = winPlanMgmtData.action_owner;
							winPlan.project_values[proj_val].location_ref = winPlanMgmtData.location_ref;
						}
					}
					section_id = "project_values";
				} else if (winPlanMgmtData.headerName === "Stakeholder Needs") {
					for (var stack_need = 0; stack_need < winPlan.stakeholder_needs.length; stack_need++) {
						if (winPlanMgmtData.sectionName === winPlan.stakeholder_needs[stack_need].advisor) {
							for (var need = 0; need < winPlan.stakeholder_needs[stack_need].objects.length; need++) {
								if (winPlanMgmtData.theme === winPlan.stakeholder_needs[stack_need].objects[need].needs) {
									winPlan.stakeholder_needs[stack_need].objects[need].comments = winPlanMgmtData.comments;
									winPlan.stakeholder_needs[stack_need].objects[need].action_taken = winPlanMgmtData.action_taken;
									winPlan.stakeholder_needs[stack_need].objects[need].action_bydate = winPlanMgmtData.action_bydate;
									winPlan.stakeholder_needs[stack_need].objects[need].win_plan_user = winPlanMgmtData.winPlanActionOwner;
									winPlan.stakeholder_needs[stack_need].objects[need].action_owner = winPlanMgmtData.action_owner;
									winPlan.stakeholder_needs[stack_need].objects[need].location_ref = winPlanMgmtData.location_ref;
								}
							}
						}
					}
					section_id = "stakeholder_needs";
				} else if (winPlanMgmtData.headerName === "Stakeholder Objectives") {
					for (var stack_obj = 0; stack_obj < winPlan.stakeholder_objectives.length; stack_obj++) {
						if (winPlanMgmtData.sectionName === winPlan.stakeholder_objectives[stack_obj].advisor) {
							for (var obj = 0; obj < winPlan.stakeholder_objectives[stack_obj].objects.length; obj++) {
								if (winPlanMgmtData.theme === winPlan.stakeholder_objectives[stack_obj].objects[obj].objectives) {
									winPlan.stakeholder_objectives[stack_obj].objects[obj].comments = winPlanMgmtData.comments;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].action_taken = winPlanMgmtData.action_taken;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].action_bydate = winPlanMgmtData.action_bydate;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].win_plan_user = winPlanMgmtData.winPlanActionOwner;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].action_owner = winPlanMgmtData.action_owner;
									winPlan.stakeholder_objectives[stack_obj].objects[obj].location_ref = winPlanMgmtData.location_ref;
								}
							}
						}
					}
					section_id = "stakeholder_objectives";
				} else if (winPlanMgmtData.headerName === "Plan Themes") {
					for (var winPlanSec = 0; winPlanSec < planSections.length; winPlanSec++) {
						if (winPlanMgmtData.sectionName === planSections[winPlanSec].win_plan_name) {
							for (var winTheme = 0; winTheme < planSections[winPlanSec].theme.length; winTheme++) {
								if (winPlanMgmtData.theme === planSections[winPlanSec].theme[winTheme].win_plan_theme) {
									planSections[winPlanSec].theme[winTheme].theme_description = winPlanMgmtData.comments;
									planSections[winPlanSec].theme[winTheme].action_taken = winPlanMgmtData.action_taken;
									planSections[winPlanSec].theme[winTheme].win_plan_user = winPlanMgmtData.action_owner;
									planSections[winPlanSec].theme[winTheme].win_plan_target_date = winPlanMgmtData.action_bydate;
									planSections[winPlanSec].theme[winTheme].action_owner = winPlanMgmtData.action_owner;
									planSections[winPlanSec].theme[winTheme].location_ref = winPlanMgmtData.location_ref;
								}
							}
						}
					}
					section_id = "Win Plan Themes";
				}
				if (winPlanMgmtData.headerName === "Stakeholder Objectives" || winPlanMgmtData.headerName === "Stakeholder Needs") {
					var stackWinPlan = _.find(winPlan[section_id], function (win) {
						return win.advisor === winPlanMgmtData.sectionName;
					});
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, stackWinPlan, winPlanMgmtData.sectionName)
					if (response.data.success) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanMgmtCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + "Updated"
						});
						// props.getData('success');
					}
				} else if (winPlanMgmtData.headerName === "Plan Themes") {
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, planSections, winPlanMgmtData.sectionName)
					if (response.data.success) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanMgmtCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + "Updated"
						});
						// props.getData('success');
					}
				} else {
					var response = await updateNewWinplan(globalOpportunityData._id, section_id, winPlan[section_id], winPlanMgmtData.sectionName)
					if (response.data.success) {
						var label = _.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name;
						setWinPlanMgmtCategoryModal(false)
						toastRef.current.showToast({
							type: 'success',
							message: label + "Updated"
						});
						// props.getData('success');
					}
				};
			}
		}


	}

	const renderFooterMgmt = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						editWinPlanMgmt ?
							<>
								<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closePopupMgmt()} />
								<ButtonElement type="submit" label="Save" className="save-button" onClick={() => saveWinplanMgmt()} />
							</>
							:
							<ButtonElement type="submit" label="Cancel" className="cancel-new-button" onClick={() => closePopupMgmt()} />
					}
				</div>
			</div>
		);
	};

	const parseDateString = (dateString) => {
		if (dateString) {
			const [day, month, year] = dateString.split('-')?.map(Number);
			return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
		}
	};

	const sectionHandleCheck = (e, index) => {
		const updatedSections = planSections.map((section, i) => {
			if (i === index) {
				return {
					...section,
					checked: true, // Set the checked property to true for the selected section
					action: 'deleteSection',
					theme: section.theme.map(item => ({
						...item,
						checked: false, // Set checked property to false for all items in the theme array
					}))
				};
			} else {
				return {
					...section,
					checked: false, // Set the checked property to false for all other sections
					action: '',
					theme: section.theme.map(item => ({
						...item,
						checked: false, // Ensure checked property is false for all items in the theme array
						action: ''
					}))
				};
			}
		});

		const selectedSection = updatedSections[index];
		setSelectedIndex([selectedSection]); // Store the selected section
		setNoAddition(true);
		setPlanSections(updatedSections);
	}

	const sectionHandle = (e, index) => {
		const updatedSections = [...planSections];

		updatedSections[index] = {
			...updatedSections[index],
			win_plan_name: e.target.value
		};
		setPlanSections(updatedSections);
	}

	const sectionHandleCheckTheme = (e, ind, index) => {
		// Create a new copy of the planSections state
		const updatedSections = planSections.map((section, secIndex) => {
			if (secIndex === index) {
				// Update the specific section
				return {
					...section,
					checked: false, // Ensure the section is not checked
					action: 'deleteTheme',
					theme: section.theme.map((item, themeIndex) => ({
						...item,
						checked: themeIndex === ind ? !item.checked : false, // Toggle check state for the clicked item
					}))
				};
			}
			return section; // Return unchanged sections
		});

		// Select the updated section
		const selectedSection = updatedSections[index];

		// Update state
		setSelectedIndex([selectedSection]);
		setNoAddition(false); // Ensure this state update is necessary
		setPlanSections(updatedSections);
	}

	const handleInputTheme = (e, ind, index) => {
		const updatedSections = [...planSections];

		updatedSections[index] = {
			...updatedSections[index],
			theme: updatedSections[index].theme.map((item, i) =>
				i === ind ? { ...item, win_plan_theme: e.target.value } : item
			)
		};

		setPlanSections(updatedSections);
	}

	const handleMgmtSelection = (e, index, field) => {
		setWinPlan(prevState => ({
			...prevState,
			[field]: prevState[field].map((need, i) =>
				i === index ? { ...need, action_owner: e.value } : need
			)
		}));
	};

	const handleCalenderMgmt = (e, index, field) => {
		setWinPlan(prevState => ({
			...prevState,
			[field]: prevState[field].map((need, i) =>
				i === index ? { ...need, action_bydate: Moment(e.value).format("DD-MM-YYYY") } : need
			)
		}));
	};

	const winPlanCompleted = (parentIndex, index, section, value, e, field) => {
		if (section == 'winPlan Themes') {
			setPlanSections((prevState) => {
				const updatedPlanSections = [...prevState];

				updatedPlanSections[parentIndex] = {
					...updatedPlanSections[parentIndex],
					theme: updatedPlanSections[parentIndex]?.theme.map((item, i) =>
						i === index ? { ...item, isCompleted: e.checked } : item
					)
				};

				return updatedPlanSections;
			});
		}

		if (field != undefined) {
			setWinPlan(prevState => ({
				...prevState,
				[field]: prevState[field].map((item, i) =>
					i === index
						? {
							...item,
							isCompleted: e.checked
						}
						: item
				)
			}));
		}

		if (e.checked) {
			var winPlanData = {};
			var isCompleted;
			var user = value.action_owner;
			if (section === "Opportunity Needs") {
				isCompleted = winPlan.opportunity_needs[index].isCompleted;
			} else if (section === "Opportunity Objectives") {
				isCompleted = winPlan.opportunity_objectives[index].isCompleted;
			} else if (section === "Opportunity Values") {
				isCompleted = winPlan.opportunity_values[index].isCompleted;
			} else if (section === "Project Needs") {
				isCompleted = winPlan.project_needs[index].isCompleted;
			} else if (section === "Project Objectives") {
				isCompleted = winPlan.project_objectives[index].isCompleted;
			} else if (section === "Project Values") {
				isCompleted = winPlan.project_values[index].isCompleted;
			} else if (section === "Stakeholder Needs") {
				isCompleted = winPlan.stakeholder_needs[parentIndex].objects[index].isCompleted;
			} else if (section === "Stakeholder Objectives") {
				isCompleted = winPlan.stakeholder_objectives[parentIndex].objects[index].isCompleted;
			} else if (section === "winPlan Themes") {
				user = value.win_plan_user;
				isCompleted = planSections[parentIndex].theme[index].isCompleted;
			}
			var winPlanMgmtData = {
				section: section,
				status: isCompleted,
				index: index,
				parentIndex: parentIndex,
				value: {...value, isCompleted: e.checked},
				isCompleted: e.checked
			};
			setWinPlanMgmtData(winPlanMgmtData)
			var userIndex = _.findIndex(user, function (u) {
				return u.id === tmpData.userid || u._id === tmpData.userid;
			});

			if (value._id != undefined) {
				if (userIndex != -1) {
					setIsWinPlanActionOwnerSame(true)
					setWinPlanManagementCompletedModal(true)
				} else {
					setIsWinPlanActionOwnerSame(false)
					setWinPlanManagementCompletedModal(true)
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Please save the task"
				});
				setIsCompletedState(true)
				setParentIndex(parentIndex)
				setSubIndex(index)
			}
		}
	};

	const handleMgmtSelectionStake = (e, index, ind, field, field1) => {
		setWinPlan(prevState => ({
			...prevState,
			[field]: prevState[field].map((item, i) =>
				i === index
					? {
						...item,
						[field1]: item[field1].map((need, j) =>
							j === ind ? { ...need, action_owner: e.value } : need
						)
					}
					: item
			)
		}));
	};

	const handleCalenderMgmtStake = (e, index, ind, field, field1) => {
		setWinPlan(prevState => ({
			...prevState,
			[field]: prevState[field].map((item, i) =>
				i === index
					? {
						...item,
						[field1]: item[field1].map((need, j) =>
							j === ind
								? { ...need, action_bydate: Moment(e.value).format("DD-MM-YYYY") }
								: need
						)
					}
					: item
			)
		}));
	};

	const handleMgmtSelectionPlan = (e, index, ind) => {
		const updatedSections = [...planSections];
		setWinPlanMgmtData((prevState) => ({
			...prevState,
			action_owner: e.value
		}))

		updatedSections[index] = {
			...updatedSections[index],
			theme: updatedSections[index].theme.map((item, i) =>
				i === ind
					? { ...item, win_plan_user: e.value }
					: item
			)
		};
		setPlanSections(updatedSections);
	};

	const handleCalenderMgmtPlan = (e, index, ind) => {
		const updatedSections = [...planSections];

		updatedSections[index] = {
			...updatedSections[index],
			theme: updatedSections[index].theme.map((item, i) =>
				i === ind
					? { ...item, action_bydate: Moment(e.value).format("DD-MM-YYYY"), win_plan_target_date: Moment(e.value).format("DD-MM-YYYY") }
					: item
			)
		};
		setPlanSections(updatedSections);
		setWinPlanData((prevState) => ({
			...prevState,
			win_plan_target_date: Moment(e.value).format('DD-MM-YYYY')
		}))
	};

	const cancelWinPlanCompleted = (data) => {
		const { index, parentIndex, section } = data;

		// Create copies of the state objects to avoid direct mutation
		const updatedWinPlan = { ...winPlan };
		const updatedPlanSections = [...planSections];

		switch (section) {
			case "Opportunity Needs":
				updatedWinPlan.opportunity_needs[index].isCompleted = false;
				break;
			case "Opportunity Objectives":
				updatedWinPlan.opportunity_objectives[index].isCompleted = false;
				break;
			case "Opportunity Values":
				updatedWinPlan.opportunity_values[index].isCompleted = false;
				break;
			case "Project Needs":
				updatedWinPlan.project_needs[index].isCompleted = false;
				break;
			case "Project Objectives":
				updatedWinPlan.project_objectives[index].isCompleted = false;
				break;
			case "Project Values":
				updatedWinPlan.project_values[index].isCompleted = false;
				break;
			case "Stakeholder Needs":
				updatedWinPlan.stakeholder_needs[parentIndex].objects[index].isCompleted = false;
				break;
			case "Stakeholder Objectives":
				updatedWinPlan.stakeholder_objectives[parentIndex].objects[index].isCompleted = false;
				break;
			case "winPlan Themes":
				updatedPlanSections[parentIndex].theme[index].isCompleted = false;
				break;
			default:
				break;
		}

		// Update state with new objects
		setWinPlan((prevState) => ({
			...prevState,
			...updatedWinPlan
		}));

		setPlanSections((prevState) => {
			const updatedPlanSections = [...prevState];

			if (!updatedPlanSections[parentIndex] || !updatedPlanSections[parentIndex].theme) {
				return prevState;
			}

			updatedPlanSections[parentIndex] = {
				...updatedPlanSections[parentIndex],
				theme: updatedPlanSections[parentIndex].theme.map((item, i) =>
					i === index ? { ...item, isCompleted: false } : item
				)
			};

			return updatedPlanSections;
		});
		setWinPlanManagementCompletedModal(false)
	};

	// const modalWinPlanCompleted = async (data) => {
	// 	var parentIndex = data.parentIndex;
	// 	var index = data.index;
	// 	var section = data.section;
	// 	var tmpPlan = data.value;

	// 	var data = await wplanActionComplete(opportunityData._id, props.customerId, parentIndex, index, section, tmpPlan)
	// 	if (data.data) {
	// 		if (data.data.success) {
	// 			var clearCompNotify = await clearCompletedNotification(tmpPlan._id)
	// 			if (clearCompNotify.data) {
	// 				if (clearCompNotify.data.status) {
	// 					socket.emit('pushNotifications', props.customerId)
	// 				}
	// 			}
	// 			setWinPlanManagementCompletedModal(false)
	// 			toastRef.current.showToast({
	// 				type: 'success',
	// 				message: data.data.message
	// 			});
	// 		}
	// 	};
	// }
	const modalWinPlanCompleted = async (data) => {

		try {
			// Extract necessary values from the input data
			const parentIndex = data.parentIndex;
			const index = data.index;
			const section = data.section;
			const tmpPlan = data.value;

			// Call API to complete the win plan action
			const response = await wplanActionComplete(
				opportunityData._id,
				props.customerId,
				parentIndex,
				index,
				section,
				tmpPlan
			);

			// Check if the response is valid and contains success status
			if (response && response.data && response.data.success) {
				// Clear the completed notification
				const clearCompNotify = await clearCompletedNotification(tmpPlan._id);

				// Check if the clear notification response is valid
				if (clearCompNotify && clearCompNotify.data && clearCompNotify.data.status) {
					socket.emit('pushNotifications', props.customerId); // Emit notification
				}

				setWinPlanManagementCompletedModal(false);
				// Show success toast
				toastRef.current.showToast({
					type: 'success',
					message: response.data.message,
				});
			} else {
				// Handle cases where the API response does not indicate success
				toastRef.current.showToast({
					type: 'error',
					message: response?.data?.message || 'Failed to complete the win plan action. Please try again.',
				});
			}
		} catch (error) {
			// Handle any errors during the process
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred while completing the win plan. Please try again or contact Admin.',
			});
		}
	};


	const renderCompletedFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						isWinPlanActionOwnerSame ?
							<>
								<ButtonElement label="No" className="cancel-new-button" onClick={() => cancelWinPlanCompleted(winPlanMgmtData)} />
								<ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalWinPlanCompleted(winPlanMgmtData)} />
							</>
							:
							<ButtonElement type="submit" label="Close" className="save-button" onClick={() => cancelWinPlanCompleted(winPlanMgmtData)} />
					}
				</div>
			</div>
		);
	};

	const dropdownRef = useRef(null);
	const handleOutsideClick = (event) => {
		if (showDropdown) {
			const target = event.target;
			const dropdownButton = document.querySelector('.clear-filter-button');
			const dropdownContent = document.querySelector('.s-field');
			const multiSelectInput = document.querySelector('.p-multiselect-filter');

			// Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
			if (
				!dropdownContent.contains(target) &&
				target !== dropdownButton &&
				target !== multiSelectInput &&
				!target.closest('.p-multiselect-item') && // MultiSelect items
				!target.closest('.p-dropdown-item') // Single select dropdown items
			) {
				setShowDropdown(false);
			}
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [showDropdown]);

	const [isValidURL, setIsValidURL] = useState(true);

	const validateURL = (url) => {

		if (!url) {
			return true;
		}
		const urlPattern = new RegExp(
			"^(https?:\\/\\/)?([\\w-]+\\.)+[\\w-]+(/[\\w- ./?%&=]*)?$"
		);
		return !!urlPattern.test(url);
	};

	const handleChange = (e) => {
		const inputValue = e.target.value;
		const isValid = validateURL(inputValue);
		setIsValidURL(isValid);

		setWinPlanMgmtData((prevState) => ({
			...prevState,
			location_ref: e.target.value
		}))
	};


	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			{
				!_.isEmpty(opportunityData) && <form>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field'>
													{
														_.find(props.fieldData.oppProjectTeamTable, { table_name: "Delivery Team" })?.status &&
														<div className="form-group row align-items-center mb-0 mt-10">
															{
																_.find(props.fieldData.oppWinPlanTable, { table_name: 'winPlan Identification' })?.status &&
																<>
																	<div className='d-flex'>
																		<div className='col-md-6 pl-0 d-flex'>
																			<div className="col-md-4 pl-0">
																				<label className="form-label text-left">{_.find(props.fieldData.pipelineWinplanFields, { field_name: 'winPlan Section' })?.display_name}:</label>
																			</div>
																			<div className="col-md-1 pl-0">
																				{
																					props.customerTooltipDataOthers?.win_plan.win_plan_section.status == true &&
																					<div>
																						<Tooltip target=".custom-target-icon" />

																						<i className="custom-target-icon pi pi-info-circle tooltip-font"
																							data-pr-tooltip={props.customerTooltipDataOthers?.win_plan.win_plan_section.text}
																							data-pr-position="right">
																						</i>
																					</div>
																				}
																			</div>
																			<div className='col pr-0'>
																				<MultiSelect
																					value={selectedModel}
																					options={groupData}
																					onChange={(e) => winPlanLoad(e)}
																					optionLabel="label"
																					optionGroupLabel="label"
																					optionGroupChildren="items"
																					optionGroupTemplate={groupedItemTemplate}
																					placeholder="Select"
																					display="chip"
																					className="w-full"
																					maxSelectedLabels={1}
																					showSelectAll={false}
																				/>
																			</div>
																		</div>
																	</div>
																	<div>
																		<div className='col-md-6 pl-0'>
																			<div>
																				<div className="form-group row align-items-center mb-0 mt-0">
																					<div className="col-md-4 pl-0">
																						<label className="form-label text-left">Activity Plan Status:</label>
																					</div>
																				</div>
																				<div className="form-group row align-items-center mb-0 mt-0">
																					<div className="col-md-1 pl-0"></div>
																					<div className="col-md-5 pl-0">
																						<label className="form-label text-left">Completion: </label>
																					</div>
																					<div className="col pl-0">
																						<label className="form-label text-left">{completePercentage}%</label>
																					</div>
																				</div>
																				<div className="form-group row align-items-center mb-0 mt-0">
																					<div className="col-md-1 pl-0"></div>
																					<div className="col-md-5 pl-0">
																						<label className="form-label text-left">Current Completed Task: </label>
																					</div>
																					<div className="col pl-0">
																						<label className="form-label text-left">{completeCount + " / " + totalCount}</label>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</>
															}
															{
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col pr-0 d-flex justify-end delete-icon">
																		<ButtonElement type="button" icon="pi pi-filter-slash" className="edit-option-button font-text" onClick={resetButton} />
																		<div className='p-relative ml-20' ref={dropdownRef}>
																			<ButtonElement type="button" className="edit-option-button" icon="pi pi-filter" onClick={toggleDropdown} />
																			{showDropdown && (
																				<>
																					<div className='s-field'>
																						<div className='new-field w-100'>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Action Owner:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedOwner}
																										optionLabel="label"
																										options={props.relationshipOwner}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => handleSelection(e.value, selectedStatus)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Status:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedStatus}
																										optionLabel="label"
																										options={statusFilter}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => handleSelection(selectedOwner, e.value)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																						</div>
																					</div>
																				</>
																			)}
																		</div>
																		<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-trash" onClick={removePlan} />
																		<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-plus" onClick={() => addNewPlan(noAddition)} />
																	</div>
																</div>
															}
														</div>
													}
													{
														_.find(props.fieldData.oppWinPlanTable, { table_name: 'winPlan Identification' })?.status &&
														<div className="group-table-data">
															<table className="group-datatable">
																<thead className="group-table-header">
																	<tr>
																		<th className="checkbox-header"></th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanIdenHeaders, { header_name: 'Section' })?.display_name}</th>
																		<th className="w-25">{_.find(props.fieldData.oppWinplanIdenHeaders, { header_name: 'Theme' })?.display_name}</th>
																		<th className="w-25">{_.find(props.fieldData.oppWinplanIdenHeaders, { header_name: 'Background' })?.display_name}</th>
																		<th className="w-20">{_.find(props.fieldData.oppWinplanIdenHeaders, { header_name: 'Planned Action' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanIdenHeaders, { header_name: 'View / Edit' })?.display_name}</th>
																	</tr>
																</thead>
																<tbody className="group-table-row stakeplan">
																	{
																		winPlan.opportunity_needs && winPlan.opportunity_needs.length > 0 && winPlan.opportunity_needs.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Clients Stated Project Needs' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.opportunity_needs && winPlan.opportunity_needs.length > 0 && winPlan.opportunity_needs.showSec != false && winPlan.opportunity_needs.map((oppNeeds, index) => {
																			return (
																				oppNeeds.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppNeeds.needs && oppNeeds.needs}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppNeeds.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{oppNeeds.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Opportunity Needs', oppNeeds)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Opportunity Needs', oppNeeds, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.opportunity_objectives && winPlan.opportunity_objectives.length > 0 && winPlan.opportunity_objectives.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Clients Stated Project Objectives' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.opportunity_objectives && winPlan.opportunity_objectives.length > 0 && winPlan.opportunity_objectives.showSec != false && winPlan.opportunity_objectives.map((oppObjs, index) => {
																			return (
																				oppObjs.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppObjs.objectives}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppObjs.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{oppObjs.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Opportunity Objectives', oppObjs)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Opportunity Objectives', oppObjs, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.opportunity_values && winPlan.opportunity_values.length > 0 && winPlan.opportunity_values.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Clients Stated Project Values' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.opportunity_values && winPlan.opportunity_values.length > 0 && winPlan.opportunity_values.showSec != false && winPlan.opportunity_values.map((oppVals, index) => {
																			return (
																				oppVals.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppVals.values}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{oppVals.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{oppVals.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Opportunity Values', oppVals)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Opportunity Values', oppVals, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.project_needs && winPlan.project_needs.length > 0 && winPlan.project_needs.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Specific Project Outputs' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.project_needs && winPlan.project_needs.length > 0 && winPlan.project_needs.showSec != false && winPlan.project_needs.map((projNeeds, index) => {
																			return (
																				projNeeds.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projNeeds.needs}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projNeeds.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{projNeeds.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Project Needs', projNeeds)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Project Needs', projNeeds, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.project_objectives && winPlan.project_objectives.length > 0 && winPlan.project_objectives.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Specific Project Deliverables' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.project_objectives && winPlan.project_objectives.length > 0 && winPlan.project_objectives.showSec != false && winPlan.project_objectives.map((projObjs, index) => {
																			return (
																				projObjs.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projObjs.objectives}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projObjs.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{projObjs.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Project Objectives', projObjs)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Project Objectives', projObjs, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.project_values && winPlan.project_values.length > 0 && winPlan.project_values.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Specific Project Performance' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.project_values && winPlan.project_values.length > 0 && winPlan.project_values.showSec != false && winPlan.project_values.map((projVals, index) => {
																			return (
																				projVals.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td>
																								&nbsp;
																							</td>
																							<td className='width-10'>
																								&nbsp;
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projVals.values}</label>
																							</td>
																							<td className='w-25'>
																								<label className="form-label text-left">{projVals.category}</label>
																							</td>
																							<td className='w-20'>
																								<label className="form-label text-left">{projVals.planned_action}</label>
																							</td>
																							<td className='width-10'>
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlan(false, 'Project Values', projVals)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlan(true, 'Project Values', projVals, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.stakeholder_needs && winPlan.stakeholder_needs.length > 0 && winPlan.stakeholder_needs.map((stackNeeds, index) => {
																			return (
																				<React.Fragment key={index}>
																					{
																						stackNeeds.showSec != false &&
																						<tr>
																							<td className="group-header">
																								&nbsp;
																							</td>
																							<td className="group-header" colSpan={6}>
																								<label className="form-label text-left"> Specific Project Outputs - {stackNeeds.advisor}</label>
																							</td>
																						</tr>
																					}
																					{
																						stackNeeds.objects.length > 0 && stackNeeds.objects.map((object, ind) => {
																							return (
																								object.showRec != false && (
																									<tr>
																										<td>
																											&nbsp;
																										</td>
																										<td className='width-10'>
																											&nbsp;
																										</td>
																										<td className='w-25'>
																											<label className="form-label text-left">{object.needs && object.needs}</label>
																										</td>
																										<td className='w-25'>
																											<label className="form-label text-left">{object.needs && object.category}</label>
																										</td>
																										<td className='w-20'>
																											<label className="form-label text-left">{object.needs && object.planned_action}</label>
																										</td>
																										<td className='width-10'>
																											<InputIcon
																												className="pi pi-eye ml-0"
																												onClick={() => openWinPlan(false, stackNeeds.advisor + ' - Stakeholder Needs', object)}
																											/>
																											<InputIcon
																												className="pi pi-pencil ml-10"
																												onClick={() => openWinPlan(true, stackNeeds.advisor + ' - Stakeholder Needs', object, stackNeeds.advisor, 'Stakeholder Needs', ind)}
																											/>
																										</td>
																									</tr>
																								)
																							)
																						})
																					}
																				</React.Fragment>
																			)
																		})
																	}
																	{
																		winPlan.stakeholder_objectives && winPlan.stakeholder_objectives.length > 0 && winPlan.stakeholder_objectives.map((stackObjs, index) => {
																			return (
																				<React.Fragment key={index}>
																					{
																						stackObjs.showSec != false &&
																						<tr>
																							<td className="group-header">
																								&nbsp;
																							</td>
																							<td className="group-header" colSpan={6}>
																								<label className="form-label text-left"> Specific Project Deliverables - {stackObjs.advisor}</label>
																							</td>
																						</tr>
																					}
																					{
																						stackObjs.objects.length > 0 && stackObjs.objects.map((object, ind) => {
																							return (
																								object.showRec != false && (
																									<tr>
																										<td>
																											&nbsp;
																										</td>
																										<td className='width-10'>
																											&nbsp;
																										</td>
																										<td className='w-25'>
																											<label className="form-label text-left">{object.objectives && object.objectives}</label>
																										</td>
																										<td className='w-25'>
																											<label className="form-label text-left">{object.objectives && object.category}</label>
																										</td>
																										<td className='w-20'>
																											<label className="form-label text-left">{object.objectives && object.planned_action}</label>
																										</td>
																										<td className='width-10'>
																											<InputIcon
																												className="pi pi-eye ml-0"
																												onClick={() => openWinPlan(false, stackObjs.advisor + ' - Stakeholder Objectives', object)}
																											/>
																											<InputIcon
																												className="pi pi-pencil ml-10"
																												onClick={() => openWinPlan(true, stackObjs.advisor + ' - Stakeholder Objectives', object, stackObjs.advisor, 'Stakeholder Objectives', ind)}
																											/>
																										</td>
																									</tr>
																								)
																							)
																						})
																					}
																				</React.Fragment>
																			)
																		})
																	}
																	{
																		planSections && planSections.length > 0 && showWinPlanHeader != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header">
																					&nbsp;
																				</td>
																				<td className="group-header" colSpan={6}>
																					<label className="form-label text-left">{_.find(props.fieldData.pipelineWinplanFields, { field_name: 'winPlan Section' })?.display_name + ' Themes'}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		planSections && planSections.length > 0 && planSections.map((subscription, index) => {
																			return (
																				subscription.showSec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td className="group-header">
																								<CheckboxElement
																									id={`subscription-${index}`}
																									name={`subscription-${index}`}
																									checked={subscription.checked}
																									onChangeCheck={(e) => sectionHandleCheck(e, index)}
																									className="mr-2"
																								/>
																							</td>
																							<td className="group-header" colSpan={2}>
																								<InputTextElementElement
																									id="win_plan_name"
																									name="win_plan_name"
																									value={subscription.win_plan_name}
																									onChange={e => sectionHandle(e, index)}
																									required
																									className="w-full"
																								/>
																							</td>
																							<td className="group-header" colSpan={4}>
																								&nbsp;
																							</td>
																						</tr>
																						{
																							subscription.theme.length > 0 && subscription.theme.map((sub, ind) => {
																								return (
																									sub.showRec != false && (
																										<tr>
																											<td>
																												&nbsp;
																											</td>
																											<td className='width-10'>
																												<CheckboxElement
																													id={`sub-${ind}`}
																													name={`sub-${ind}`}
																													checked={sub.checked}
																													onChangeCheck={(e) => sectionHandleCheckTheme(e, ind, index)}
																													className="mr-2"
																												/>
																											</td>
																											<td className='w-25'>
																												<InputTextElementElement
																													id="win_plan_theme"
																													name="win_plan_theme"
																													value={sub.win_plan_theme}
																													onChange={(e) => handleInputTheme(e, ind, index)}
																													required
																													className="w-full"
																												/>
																											</td>
																											<td className='w-25'>
																												{sub.theme_description}
																											</td>
																											<td className='w-20'>
																												{sub.planned_action}
																											</td>
																											<td className='width-10'>
																												<InputIcon
																													className="pi pi-eye ml-0"
																													onClick={() => openWinPlan(false, subscription.win_plan_name + ' - Plan Themes', sub)}
																												/>
																												<InputIcon
																													className="pi pi-pencil ml-10"
																													onClick={() => openWinPlan(true, subscription.win_plan_name + ' - Plan Themes', sub, subscription.win_plan_name, 'Plan Themes', ind)}
																												/>
																											</td>
																										</tr>
																									)
																								)
																							})
																						}
																					</React.Fragment>
																				)
																			)
																		})
																	}
																</tbody>
															</table>
														</div>
													}
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppWinPlanTable, { table_name: 'winPlan Management' })?.status &&
														<div className="group-table-data risks-tab">
															<table className="group-datatable activity">
																<thead className="group-table-header">
																	<tr>
																		<th className="width-5">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Section' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Theme' })?.display_name}</th>
																		<th className="width-15">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Action Owner' })?.display_name}</th>
																		<th className="width-15">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Action By Date' })?.display_name}</th>
																		<th className="width-15">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Action Taken' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Comments' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Reference' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Completed' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppWinplanManageHeaders, { header_name: 'Action' })?.display_name}</th>
																	</tr>
																</thead>
																<tbody className="group-table-row stakeplan">
																	{
																		winPlan.opportunity_needs && winPlan.opportunity_needs.length > 0 && winPlan.opportunity_needs.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header" colSpan={9}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Clients Stated Project Needs' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.opportunity_needs && winPlan.opportunity_needs.length > 0 && winPlan.opportunity_needs.map((oppNeeds, index) => {
																			return (
																				oppNeeds.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td className="width-5">
																								&nbsp;
																							</td>
																							<td className="width-10">
																								{oppNeeds.needs}
																							</td>
																							<td className="width-15">
																								<MultiSelectElement
																									value={oppNeeds.action_owner}
																									optionLabel="label"
																									options={props.relationshipOwner}
																									placeholder="-- Please select --"
																									maxSelectedLabels={1}
																									onChangeValue={(e) => handleMgmtSelection(e, index, 'opportunity_needs')}
																									className="w-full"
																								/>
																							</td>
																							<td className="width-15">
																								<CalendarElement
																									id="date"
																									className='ml-10'
																									value={parseDateString(oppNeeds.action_bydate)}
																									onChange={(e) => handleCalenderMgmt(e, index, 'opportunity_needs')}
																									maxLength="50"
																									placeholder="Choose a date"
																									autocomplete="off"
																								/>
																							</td>
																							<td className="width-15">
																								{oppNeeds.action_taken}
																							</td>
																							<td className="width-10">
																								{oppNeeds.comments}
																							</td>
																							<td className="width-10">
																								<a target="_blank" href={oppNeeds.location_ref}>{oppNeeds.location_ref}</a>
																							</td>
																							<td className="width-5">
																								<CheckboxElement
																									id={`complete-${index}`}
																									name={`complete-${index}`}
																									checked={oppNeeds.isCompleted}
																									onChangeCheck={(e) => winPlanCompleted(index, index, 'Opportunity Needs', oppNeeds, e, 'opportunity_needs')}
																									className="mr-2"
																								/>
																							</td>
																							<td className="width-15">
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlanMgmt(false, 'Opportunity Needs', oppNeeds)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlanMgmt(true, 'Opportunity Needs', oppNeeds, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.opportunity_objectives && winPlan.opportunity_objectives.length > 0 && winPlan.opportunity_objectives.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header" colSpan={9}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Clients Stated Project Objectives' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.opportunity_objectives && winPlan.opportunity_objectives.length > 0 && winPlan.opportunity_objectives.map((oppObjs, index) => {
																			return (
																				oppObjs.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td className="width-5">
																								&nbsp;
																							</td>
																							<td className="width-10">
																								{oppObjs.objectives}
																							</td>
																							<td className="width-15">
																								<MultiSelectElement
																									value={oppObjs.action_owner}
																									optionLabel="label"
																									options={props.relationshipOwner}
																									placeholder="-- Please select --"
																									maxSelectedLabels={1}
																									onChangeValue={(e) => handleMgmtSelection(e, index, 'opportunity_objectives')}
																									className="w-full"
																								/>
																							</td>
																							<td className="width-15">
																								<CalendarElement
																									id="date"
																									className='ml-10'
																									value={parseDateString(oppObjs.action_bydate)}
																									onChange={(e) => handleCalenderMgmt(e, index, 'opportunity_objectives')}
																									maxLength="50"
																									placeholder="Choose a date"
																									autocomplete="off"
																								/>
																							</td>
																							<td className="width-15">
																								{oppObjs.action_taken}
																							</td>
																							<td className="width-10">
																								{oppObjs.comments}
																							</td>
																							<td className="width-10">
																								<a target="_blank" href={oppObjs.location_ref}>{oppObjs.location_ref}</a>
																							</td>
																							<td className="width-5">
																								<CheckboxElement
																									id={`complete-${index}`}
																									name={`complete-${index}`}
																									checked={oppObjs.isCompleted}
																									onChangeCheck={(e) => winPlanCompleted(index, index, 'Opportunity Objectives', oppObjs, e, 'opportunity_objectives')}
																									className="mr-2"
																								/>
																							</td>
																							<td className="width-15">
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlanMgmt(false, 'Opportunity Objectives', oppObjs)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlanMgmt(true, 'Opportunity Objectives', oppObjs, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.project_needs && winPlan.project_needs.length > 0 && winPlan.project_needs.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header" colSpan={9}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Specific Project Outputs' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.project_needs && winPlan.project_needs.length > 0 && winPlan.project_needs.map((projNeeds, index) => {
																			return (
																				projNeeds.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td className="width-5">
																								&nbsp;
																							</td>
																							<td className="width-10">
																								{projNeeds.needs}
																							</td>
																							<td className="width-15">
																								<MultiSelectElement
																									value={projNeeds.action_owner}
																									optionLabel="label"
																									options={props.relationshipOwner}
																									placeholder="-- Please select --"
																									maxSelectedLabels={1}
																									onChangeValue={(e) => handleMgmtSelection(e, index, 'project_needs')}
																									className="w-full"
																								/>
																							</td>
																							<td className="width-15">
																								<CalendarElement
																									id="date"
																									className='ml-10'
																									value={parseDateString(projNeeds.action_bydate)}
																									onChange={(e) => handleCalenderMgmt(e, index, 'project_needs')}
																									maxLength="50"
																									placeholder="Choose a date"
																									autocomplete="off"
																								/>
																							</td>
																							<td className="width-15">
																								{projNeeds.action_taken}
																							</td>
																							<td className="width-10">
																								{projNeeds.comments}
																							</td>
																							<td className="width-10">
																								<a target="_blank" href={projNeeds.location_ref}>{projNeeds.location_ref}</a>
																							</td>
																							<td className="width-5">
																								<CheckboxElement
																									id={`complete-${index}`}
																									name={`complete-${index}`}
																									checked={projNeeds.isCompleted}
																									onChangeCheck={(e) => winPlanCompleted(index, index, 'Project Needs', projNeeds, e, 'project_needs')}
																									className="mr-2"
																								/>
																							</td>
																							<td className="width-15">
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlanMgmt(false, 'Project Needs', projNeeds)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlanMgmt(true, 'Project Needs', projNeeds, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.project_objectives && winPlan.project_objectives.length > 0 && winPlan.project_objectives.showSec != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header" colSpan={9}>
																					<label className="form-label text-left">{_.find(props.fieldData.oppClientTable, { table_name: 'Specific Project Deliverables' })?.display_name}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		winPlan.project_objectives && winPlan.project_objectives.length > 0 && winPlan.project_objectives.map((projObjs, index) => {
																			return (
																				projObjs.showRec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td className="width-5">
																								&nbsp;
																							</td>
																							<td className="width-10">
																								{projObjs.objectives}
																							</td>
																							<td className="width-15">
																								<MultiSelectElement
																									value={projObjs.action_owner}
																									optionLabel="label"
																									options={props.relationshipOwner}
																									placeholder="-- Please select --"
																									maxSelectedLabels={1}
																									onChangeValue={(e) => handleMgmtSelection(e, index, 'project_objectives')}
																									className="w-full"
																								/>
																							</td>
																							<td className="width-15">
																								<CalendarElement
																									id="date"
																									className='ml-10'
																									value={parseDateString(projObjs.action_bydate)}
																									onChange={(e) => handleCalenderMgmt(e, index, 'project_objectives')}
																									maxLength="50"
																									placeholder="Choose a date"
																									autocomplete="off"
																								/>
																							</td>
																							<td className="width-15">
																								{projObjs.action_taken}
																							</td>
																							<td className="width-10">
																								{projObjs.comments}
																							</td>
																							<td className="width-10">
																								<a target="_blank" href={projObjs.location_ref}>{projObjs.location_ref}</a>
																							</td>
																							<td className="width-5">
																								<CheckboxElement
																									id={`complete-${index}`}
																									name={`complete-${index}`}
																									checked={projObjs.isCompleted}
																									onChangeCheck={(e) => winPlanCompleted(index, index, 'Project Objectives', projObjs, e, 'project_objectives')}
																									className="mr-2"
																								/>
																							</td>
																							<td className="width-15">
																								<InputIcon
																									className="pi pi-eye ml-0"
																									onClick={() => openWinPlanMgmt(false, 'Project Objectives', projObjs)}
																								/>
																								<InputIcon
																									className="pi pi-pencil ml-10"
																									onClick={() => openWinPlanMgmt(true, 'Project Objectives', projObjs, '', '', index)}
																								/>
																							</td>
																						</tr>
																					</React.Fragment>
																				)
																			)
																		})
																	}
																	{
																		winPlan.stakeholder_needs && winPlan.stakeholder_needs.length > 0 && winPlan.stakeholder_needs.map((stackNeeds, index) => {
																			return (
																				<React.Fragment key={index}>
																					{
																						stackNeeds.showSec != false &&
																						<tr>
																							<td className='group-header' colSpan={10}>
																								<label className="form-label text-left"> Specific Project Outputs - {stackNeeds.advisor}</label>
																							</td>
																						</tr>
																					}
																					{
																						stackNeeds.objects.length > 0 && stackNeeds.objects.map((object, ind) => {
																							return (
																								object.showRec != false && (
																									<tr>
																										<td className="width-5">
																											&nbsp;
																										</td>
																										<td className="width-10">
																											{object.needs}
																										</td>
																										<td className="width-15">
																											<MultiSelectElement
																												value={object.action_owner}
																												optionLabel="label"
																												options={props.relationshipOwner}
																												placeholder="-- Please select --"
																												maxSelectedLabels={1}
																												onChangeValue={(e) => handleMgmtSelectionStake(e, index, ind, 'stakeholder_needs', 'objects')}
																												className="w-full"
																											/>
																										</td>
																										<td className="width-15">
																											<CalendarElement
																												id="date"
																												className='ml-10'
																												value={parseDateString(object.action_bydate)}
																												onChange={(e) => handleCalenderMgmtStake(e, index, ind, 'stakeholder_needs', 'objects')}
																												maxLength="50"
																												placeholder="Choose a date"
																												autocomplete="off"
																											/>
																										</td>
																										<td className="width-15">
																											{object.action_taken}
																										</td>
																										<td className="width-10">
																											{object.comments}
																										</td>
																										<td className="width-10">
																											<a target="_blank" href={object.location_ref}>{object.location_ref}</a>
																										</td>
																										<td className="width-5">
																											<CheckboxElement
																												id={`complete-${index}`}
																												name={`complete-${index}`}
																												checked={object.isCompleted}
																												onChangeCheck={(e) => winPlanCompleted(index, ind, 'Stakeholder Needs', object, e, 'stakeholder_needs')}
																												className="mr-2"
																											/>
																										</td>
																										<td className="width-15">
																											<InputIcon
																												className="pi pi-eye ml-0"
																												onClick={() => openWinPlanMgmt(false, stackNeeds.advisor + ' - Stakeholder Needs', object)}
																											/>
																											<InputIcon
																												className="pi pi-pencil ml-10"
																												onClick={() => openWinPlanMgmt(true, stackNeeds.advisor + ' - Stakeholder Needs', object, stackNeeds.advisor, 'Stakeholder Needs', index)}
																											/>
																										</td>
																									</tr>
																								)
																							)
																						})
																					}
																				</React.Fragment>
																			)
																		})
																	}
																	{
																		winPlan.stakeholder_objectives && winPlan.stakeholder_objectives.length > 0 && winPlan.stakeholder_objectives.map((stackObjs, index) => {
																			return (
																				<React.Fragment key={index}>
																					{
																						stackObjs.showSec != false &&
																						<tr>
																							<td className='group-header' colSpan={10}>
																								<label className="form-label text-left"> Specific Project Deliverables - {stackObjs.advisor}</label>
																							</td>
																						</tr>
																					}
																					{
																						stackObjs.objects.length > 0 && stackObjs.objects.map((object, ind) => {
																							return (
																								object.showRec != false && (
																									<tr>
																										<td className="width-5">
																											&nbsp;
																										</td>
																										<td className="width-10">
																											{object.objectives}
																										</td>
																										<td className="width-15">
																											<MultiSelectElement
																												value={object.action_owner}
																												optionLabel="label"
																												options={props.relationshipOwner}
																												placeholder="-- Please select --"
																												maxSelectedLabels={1}
																												onChangeValue={(e) => handleMgmtSelectionStake(e, index, ind, 'stakeholder_objectives', 'objects')}
																												className="w-full"
																											/>
																										</td>
																										<td className="width-15">
																											<CalendarElement
																												id="date"
																												className='ml-10'
																												value={parseDateString(object.action_bydate)}
																												onChange={(e) => handleCalenderMgmtStake(e, index, ind, 'stakeholder_objectives', 'objects')}
																												maxLength="50"
																												placeholder="Choose a date"
																												autocomplete="off"
																											/>
																										</td>
																										<td className="width-15">
																											{object.action_taken}
																										</td>
																										<td className="width-10">
																											{object.comments}
																										</td>
																										<td className="width-10">
																											<a target="_blank" href={object.location_ref}>{object.location_ref}</a>
																										</td>
																										<td className="width-5">
																											<CheckboxElement
																												id={`complete-${index}`}
																												name={`complete-${index}`}
																												checked={object.isCompleted}
																												onChangeCheck={(e) => winPlanCompleted(index, ind, 'Stakeholder Objectives', object, e, 'stakeholder_objectives')}
																												className="mr-2"
																											/>
																										</td>
																										<td className="width-15">
																											<InputIcon
																												className="pi pi-eye ml-0"
																												onClick={() => openWinPlanMgmt(false, stackObjs.advisor + ' - Stakeholder Objectives', object)}
																											/>
																											<InputIcon
																												className="pi pi-pencil ml-10"
																												onClick={() => openWinPlanMgmt(true, stackObjs.advisor + ' - Stakeholder Objectives', object, stackObjs.advisor, 'Stakeholder Objectives', index)}
																											/>
																										</td>
																									</tr>
																								)
																							)
																						})
																					}
																				</React.Fragment>
																			)
																		})
																	}
																	{
																		planSections.length > 0 && showWinPlanHeader != false &&
																		<React.Fragment>
																			<tr>
																				<td className="group-header" colSpan={9}>
																					<label className="form-label text-left">{_.find(props.fieldData.pipelineWinplanFields, { field_name: 'winPlan Section' })?.display_name + ' Themes'}</label>
																				</td>
																			</tr>
																		</React.Fragment>
																	}
																	{
																		planSections.length > 0 && planSections.map((subscription, index) => {
																			return (
																				subscription.showSec != false && (
																					<React.Fragment key={index}>
																						<tr>
																							<td colSpan={10}>
																								{subscription.win_plan_name}
																							</td>
																						</tr>
																						{
																							subscription.theme.length > 0 && subscription.theme.map((sub, ind) => {
																								return (
																									sub.showRec != false && (
																										<tr>
																											<td className="width-5">
																												&nbsp;
																											</td>
																											<td className="width-10">
																												{sub.win_plan_theme}
																											</td>
																											<td className="width-15">
																												<MultiSelectElement
																													value={props.relationshipOwner.filter(user =>
																														sub.win_plan_user.some(owner => owner._id === user._id)
																													)}
																													optionLabel="label"
																													options={props.relationshipOwner}
																													placeholder="-- Please select --"
																													maxSelectedLabels={1}
																													onChangeValue={(e) => { handleMgmtSelectionPlan(e, index, ind) }}
																													className="w-full"
																												/>
																											</td>
																											<td className="width-15">
																												<CalendarElement
																													id="date"
																													className='ml-10'
																													value={parseDateString(sub.action_bydate)}
																													onChange={(e) => handleCalenderMgmtPlan(e, index, ind)}
																													maxLength="50"
																													placeholder="Choose a date"
																													autocomplete="off"
																												/>
																											</td>
																											<td className="width-15">
																												{sub.action_taken}
																											</td>
																											<td className="width-10">
																												{sub.theme_description}
																											</td>
																											<td className="width-10">
																												<a target="_blank" href={sub.location_ref}>{sub.location_ref}</a>
																											</td>
																											<td className="width-5">
																												<CheckboxElement
																													id={`complete-${index}`}
																													name={`complete-${index}`}
																													checked={sub.isCompleted}
																													onChangeCheck={(e) => winPlanCompleted(index, ind, 'winPlan Themes', sub, e)}
																													className="mr-2"
																												/>
																											</td>
																											<td className="width-15">
																												<div className='d-flex'>
																													<InputIcon
																														className="pi pi-eye ml-0"
																														onClick={() => openWinPlanMgmt(false, subscription.win_plan_name + ' - Plan Themes', sub)}
																													/>
																													<InputIcon
																														className="pi pi-pencil ml-10"
																														onClick={() => openWinPlanMgmt(true, subscription.win_plan_name + ' - Plan Themes', sub, subscription.win_plan_name, 'Plan Themes', index)}
																													/>
																												</div>
																											</td>
																										</tr>
																									)
																								)
																							})
																						}
																					</React.Fragment>
																				)
																			)
																		})
																	}
																</tbody>
															</table>
														</div>
													}
												</div>
											}
											{
												key == 'obj3' &&
												<div className="new-field d-flex">
													<div className='col-md-6 pl-0'>
														{
															_.find(props.fieldData.oppWinPlanTable, { table_name: "Case Studies Required" })?.status &&
															<div className="form-group row mb-0 mt-0 box-border-plan">
																<div className="col pr-0">
																	<div className="form-group row align-items-center mb-0">
																		<div className="col pr-0 d-flex justify-end">
																			<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={deleteCase} />
																			<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addCase} />
																		</div>
																	</div>
																	<DataTable
																		value={opportunityData.win_plan?.case_studies_required.length > 0 ? opportunityData.win_plan?.case_studies_required : []}
																		columns={columns}
																		dataKey="_id"
																		isCheckbox={true}
																		rowClick={rowClickCase}
																		reorderClick={reorderClickCase}
																	/>
																</div>
															</div>
														}
													</div>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.fieldData.oppWinPlanTable, { table_name: "Testimonial Required" })?.status &&
															<div className="form-group row mb-0 mt-0 box-border-plan">
																<div className="col pr-0">
																	<div className="form-group row align-items-center mb-0">
																		<div className="col pr-0 d-flex justify-end">
																			<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={deleteTestimonial} />
																			<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addTestimonial} />
																		</div>
																	</div>
																	<DataTable
																		value={opportunityData.win_plan?.testimonial_required.length > 0 ? opportunityData.win_plan?.testimonial_required : []}
																		columns={columns1}
																		dataKey="_id"
																		isCheckbox={true}
																		rowClick={rowClick}
																		reorderClick={reorderClick}
																	/>
																</div>
															</div>
														}
													</div>
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
				</form>
			}
			<Dialog
				header={_.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + 's: ' + winPlanData.section}
				visible={winPlanCategoryModal}
				position="right"
				onHide={() => closePopup()}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
				className="table-dialog width-32"
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								{_.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + 'Theme'}
							</label>
						</div>
						<div className="col pr-0">
							<label className="form-label text-left">{winPlanData.theme}</label>
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Background
							</label>
						</div>
						<div className="col pr-0">
							{
								editWinPlan ?
									<TextareaElement
										placeholder="Text"
										name="winplan_category"
										className="w-full"
										value={winPlanData.category}
										onChange={(e) => setWinPlanData((prevState) => ({
											...prevState,
											category: e.target.value
										}))}
										rows={3}
									/> :
									<label className="form-label text-left">
										{winPlanData.category}
									</label>
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Planned Action
							</label>
						</div>
						<div className="col pr-0">
							{
								editWinPlan ?
									<TextareaElement
										placeholder="Text"
										name="winplan_planned_action"
										className="w-full"
										value={winPlanData.action}
										onChange={(e) => setWinPlanData((prevState) => ({
											...prevState,
											action: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{winPlanData.action}
									</label>
							}

						</div>
					</div>
					{
						editWinPlan &&
						<div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Owner
									</label>
								</div>
								<div className="col pr-0">
									<MultiSelectElement
										name
										value={props.relationshipOwner.filter(user =>
											winPlanData.winPlanActionOwner?.some(owner => owner._id === user._id)
										)}
										optionLabel="label"
										options={props.relationshipOwner}
										placeholder="-- Please select --"
										maxSelectedLabels={1}
										onChangeValue={(e) => setWinPlanData((prevState) => ({
											...prevState,
											winPlanActionOwner: e.value
										}))}
										className="w-full"
									/>
								</div>
							</div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Date
									</label>
								</div>
								<div className="col pr-0">
									<CalendarElement
										id="date"
										className='ml-10'
										value={parseDateString(winPlanData.action_bydate)}
										onChange={(e) => setWinPlanData((prevState) => ({
											...prevState,
											action_bydate: Moment(e.value).format('DD-MM-YYYY')
										}))}
										maxLength="50"
										placeholder="Choose a date"
										autocomplete="off"
									/>
								</div>
							</div>
						</div>
					}
					{
						!editWinPlan &&
						<div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Owner
									</label>
								</div>
								<div className="col pr-0">
									{
										winPlanData.winPlanActionOwner && winPlanData.winPlanActionOwner.map((owner, index) => {
											return (
												<li key={index} className="form-label text-left">
													{owner.label}
												</li>
											)
										})
									}
								</div>
							</div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Date
									</label>
								</div>
								<div className="col pr-0">
									<label className="form-label text-left">{winPlanData.action_bydate}</label>
								</div>
							</div>
						</div>
					}
				</div>
			</Dialog>
			<Dialog
				header={_.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + 's: ' + winPlanMgmtData.section}
				visible={winPlanMgmtCategoryModal}
				position="right"
				onHide={() => closePopupMgmt()}
				draggable={false}
				resizable={false}
				footer={renderFooterMgmt()}
				className="table-dialog width-32"
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								{_.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + 'Theme'}
							</label>
						</div>
						<div className="col pr-0">
							<label className="form-label text-left">{winPlanMgmtData.theme}</label>
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Action Taken
							</label>
						</div>
						<div className="col pr-0">
							{
								editWinPlanMgmt ?
									<TextareaElement
										placeholder="Text"
										name="winplan_category"
										className="w-full"
										value={winPlanMgmtData.action_taken}
										onChange={e => setWinPlanMgmtData((prevState) => ({
											...prevState,
											action_taken: e.target.value
										}))}
										rows={3}
									/> :
									<label className="form-label text-left">
										{winPlanMgmtData.action_taken}
									</label>
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Comments
							</label>
						</div>
						<div className="col pr-0">
							{
								editWinPlanMgmt ?
									<TextareaElement
										placeholder="Text"
										name="winplan_planned_action"
										className="w-full"
										value={winPlanMgmtData.comments}
										onChange={e => setWinPlanMgmtData((prevState) => ({
											...prevState,
											comments: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{winPlanMgmtData.comments}
									</label>
							}

						</div>
					</div>
					{
						editWinPlanMgmt &&
						<div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Owner
									</label>
								</div>
								<div className="col pr-0">
									<MultiSelectElement
										value={winPlanMgmtData.action_owner}
										optionLabel="label"
										options={props.relationshipOwner}
										placeholder="-- Please select --"
										maxSelectedLabels={1}
										onChangeValue={e => setWinPlanMgmtData((prevState) => ({
											...prevState,
											action_owner: e.value
										}))}
										className="w-full"
									/>
								</div>
							</div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Reference
									</label>
								</div>
								<div className="col pr-0">
									<InputTextElementElement
										id="winplan_reference_location"
										name="winplan_reference_location"
										value={winPlanMgmtData.location_ref}
										onChange={handleChange}
										className={!isValidURL ? 'error-tab w-full' : 'w-full'}
									/>
								</div>
							</div>
						</div>
					}
					{
						!editWinPlanMgmt &&
						<div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Action Owner
									</label>
								</div>
								<div className="col pr-0">
									<label className='form-label text-left'>
										{
											winPlanMgmtData.action_owner && winPlanMgmtData.action_owner.map((owner, index) => {
												return (
													<li key={index} className="form-label text-left">
														{owner.label}
													</li>
												)
											})
										}
									</label>
								</div>
							</div>
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left font-bold">
										Reference
									</label>
								</div>
								<div className="col pr-0">
									<a target="_blank" className="form-label text-left" href={winPlanMgmtData.location_ref}>{winPlanMgmtData.location_ref}</a>
								</div>
							</div>
						</div>
					}
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Status
							</label>
						</div>
						<div className="col pr-0">
							<label className='form-label text-left'>{winPlanMgmtData.status}</label>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				header={_.find(props.fieldData.pipelineWinplanFields, { field_name: "winPlan Section", })?.display_name + 's: ' + winPlanMgmtData.section}
				visible={winPlanManagementCompletedModal}
				position="right"
				onHide={() => cancelWinPlanCompleted(winPlanMgmtData)}
				draggable={false}
				resizable={false}
				footer={renderCompletedFooter()}
				className="table-dialog width-32"
			>
				<div>
					{
						isWinPlanActionOwnerSame ? <div className="confirmation-content">
							<span className="table-description">
								Are you sure to complete this action?
							</span>
						</div> :
							<div className="confirmation-content">
								<span className="table-description">
									This action belongs to another user. Your are not authorised to complete this action.
								</span>
							</div>

					}
				</div>
			</Dialog>
			<div className="cancel-footer mt-20">
				<div className='d-flex align-center justify-end pb-0'>
					<ButtonElement className="save-button" type="submit" label={`Generate ${props.fieldData.pipelineWinplansubmodule} Report`} onClick={generateWPlanReports} />
				</div>
			</div>
		</div>
	)
}

export default ActivityPlannar